import React, { useState, useEffect } from 'react';
import { useNavigate as useRouterNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api, { setActivePageHeader } from '../services/api';
import DashboardContent from './DashboardContent';
import StocksPage from './StocksPage';
import StockCardDemoPage from './StockCardDemoPage';
import RetailSalesPage from './RetailSalesPage';
import AccountsPage from './AccountsPage';
import ProspectAccountsPage from './ProspectAccountsPage';
import CrmPipelinePage from './CrmPipelinePage';
import CustomFieldsManagerPage from './CustomFieldsManagerPage';
import LeadFormEmbedPage from './LeadFormEmbedPage';
import EcomOrdersPage from './EcomOrdersPage';
import EcomCatalogEmbedPage from './EcomCatalogEmbedPage';
import ProjectsPage from './ProjectsPage';
import LostReasonsPage from './LostReasonsPage';
import SalesTargetsPage from './SalesTargetsPage';
import BABSReportPage from './BABSReportPage';
import ReorderSuggestionsPage from './ReorderSuggestionsPage';
import RfqPage from './RfqPage';
import CommandPalette from '../components/CommandPalette';
import KeyboardHelp from '../components/KeyboardHelp';
import BottomNav from '../components/BottomNav';
import Breadcrumb from '../components/Breadcrumb';
import { pageToPath, pathToPage } from '../utils/pageRoutes';
import { toast } from '../components/Toast';
import { supportsPush, getPermissionStatus, subscribeToPush, unsubscribeFromPush, isPushSubscribed, sendTestPush } from '../utils/webPush';
import DepartmentModulesPage from './DepartmentModulesPage';
import EDocumentSettingsPage from './EDocumentSettingsPage';
import EDocumentsListPage from './EDocumentsListPage';
import EDocumentInboxPage from './EDocumentInboxPage';
import VendorDashboardPage from './VendorDashboardPage';
import VendorCompaniesPage from './VendorCompaniesPage';
import VendorPlansPage from './VendorPlansPage';
import VendorMessagesPage from './VendorMessagesPage';
import VendorCustomerDetailPage from './VendorCustomerDetailPage';
import VendorTeamPage from './VendorTeamPage';
import VendorSettingsPage from './VendorSettingsPage';
import VendorLeadsPage from './VendorLeadsPage';
import VendorTicketsPage from './VendorTicketsPage';
import SupportPage from './SupportPage';
import VendorPaymentMethodsPage from './VendorPaymentMethodsPage';
import VendorReportsPage from './VendorReportsPage';
import SubscriptionBanner from '../components/SubscriptionBanner';
import PersonnelPage from './PersonnelPage';
import PendingApprovalsPage from './PendingApprovalsPage';
import ApprovedDocumentsPage from './ApprovedDocumentsPage';
import SettingsPage from './SettingsPage';
import PrintTemplatesPage from './PrintTemplatesPage';
import WarehousesPage from './WarehousesPage';
import BranchesPage from './BranchesPage';
import CampaignsPage from './CampaignsPage';
import BalanceCheckPage from './BalanceCheckPage';
import LangSwitcher from '../components/LangSwitcher';
import { useTranslation } from 'react-i18next';
import { navLabel } from '../i18n/navMap';
import SalesInvoicePage from './SalesInvoicePage';
import ExchangePage from './ExchangePage';
import BankAccountsPage from './BankAccountsPage';
import CashRegistersPage from './CashRegistersPage';
import CashMovementsPage from './CashMovementsPage';
import CashOpeningPage from './CashOpeningPage';
import CashVirmanPage from './CashVirmanPage';
import ExpenseVouchersPage from './ExpenseVouchersPage';
import ExpenseCategoriesPage from './ExpenseCategoriesPage';
import WarehouseTransfersPage from './WarehouseTransfersPage';
import RetailHubPage from './RetailHubPage';
import StockCountsPage from './StockCountsPage';
import StockOpVoucherPage from './StockOpVoucherPage';
import FinancePage from './FinancePage';
import BankVoucherPage from './BankVoucherPage';
import BankPosPage from './BankPosPage';
import CariVoucherPage from './CariVoucherPage';
import CariReceiptPage from './CariReceiptPage';
import CariPaymentPage from './CariPaymentPage';
import ChecksNotesPage from './ChecksNotesPage';
import ShoppingVouchersPage from './ShoppingVouchersPage';
import PosSlipsPage from './PosSlipsPage';
import AuditLogPage from './AuditLogPage';
import ChartOfAccountsPage from './ChartOfAccountsPage';
import AccountingMappingsPage from './AccountingMappingsPage';
import ProgramDefinitionsPage from './ProgramDefinitionsPage';
import StockSeriesPage from './StockSeriesPage';
import ColorSizeWizardPage from './ColorSizeWizardPage';
import PlasiyerRoutesPage from './PlasiyerRoutesPage';
import PlasiyerDailyPage from './PlasiyerDailyPage';
import CommissionReportPage from './CommissionReportPage';
import CommissionTiersPage from './CommissionTiersPage';
import PersonnelVoucherPage from './PersonnelVoucherPage';
import FiscalPeriodsPage from './FiscalPeriodsPage';
import UsersPage from './UsersPage';
import SubscriptionPage from './SubscriptionPage';
import RolesPage from './RolesPage';
import PriceDefinitionsPage from './PriceDefinitionsPage';
import AppointmentsPage from './AppointmentsPage';
import MessagesPage from './MessagesPage';
import StockReportsHub from './StockReportsHub';
import StockListReportPage from './reports/StockListReportPage';
import ReportDesignerPage from './reports/ReportDesignerPage';
import StockLabelsPage from './StockLabelsPage';
import LabelTemplatesPage from './LabelTemplatesPage';
import LabelDesignerPage from './LabelDesignerPage';
import PergolaCalculatorPage from '../addons/pergola/PergolaCalculatorPage';
import PergolaTemplatesPage from '../addons/pergola/PergolaTemplatesPage';
import LocationsPage from './LocationsPage';
import AiAnalysisPage from './AiAnalysisPage';

function ReportsPlaceholder({ title }) {
  return (
    <div style={{ padding: 40, maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>
      <div style={{ fontSize: '3rem', marginBottom: 12 }}>📊</div>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 8 }}>{title}</h2>
      <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: 24 }}>
        Bu rapor grubu yakında geliyor. Hangi raporları görmek istediğinizi söyleyin, ekleyelim.
      </p>
      <div style={{
        display: 'inline-block',
        padding: '10px 18px',
        borderRadius: 10,
        background: 'var(--bg-card)',
        border: '1px solid var(--border-secondary)',
        fontSize: '0.82rem',
        color: 'var(--text-tertiary)',
      }}>
        Geliştirme aşamasında — örnek: bakiye dökümleri, dönemsel toplamlar, yaşlandırma analizleri…
      </div>
    </div>
  );
}

function MainLayout() {
  const { user, company, activePeriod, logout, toggleTheme, theme, selectPeriod, hasPermission, hasModule,
          isImpersonating, impersonatedByInfo, endImpersonation } = useAuth();
  const { t, i18n } = useTranslation();
  const nl = (lbl) => navLabel(lbl, i18n.language);
  // Vendor şirket kullanıcıları için varsayılan sayfa vendor-dashboard
  const isVendorCompany = company?.companyType === 'vendor';
  // Kasiyer (mağaza) modu — kullanıcı kartında is_cashier=1 ise doğrudan perakende hub'a düşer ve diğer menüler gizlenir.
  const isCashier = !!user?.isCashier;
  // HENT (vendor) firmasında: super_admin vendor paneliyle açılır, diğer kullanıcılar normal dashboard'a düşer.
  const _vendorLandingDefault = isVendorCompany && user?.role === 'super_admin';
  const _initialLanding = isCashier ? 'retail-hub' : (_vendorLandingDefault ? 'vendor-dashboard' : 'dashboard');

  // React Router senkronizasyonu — URL paylaşılabilir, tarayıcı geri butonu çalışır
  const location = useLocation();
  const routerNav = useRouterNavigate();
  const _urlInitial = pathToPage(location.pathname).page;
  const [activePage, setActivePage] = useState(_urlInitial !== 'dashboard' ? _urlInitial : _initialLanding);

  // Browser back/forward: URL değiştiğinde state'i senkronize et (sonsuz döngü güvenli)
  useEffect(() => {
    const { page: urlPage } = pathToPage(location.pathname);
    setActivePage(prev => prev === urlPage ? prev : urlPage);
  }, [location.pathname]);
  // Aktif sayfayı api interceptor'a aktar — backend'e X-Active-Page header'ı ile gider.
  useEffect(() => { setActivePageHeader(activePage); }, [activePage]);
  // Deep-link: bir sayfaya bir kaydı açacak şekilde gitmek (örn cari hareketinden bağlı faturayı tam aç)
  const [deepLink, setDeepLink] = useState(null); // { page, recordId }
  const [sidebarOpen, setSidebarOpen] = useState(() => typeof window === 'undefined' || window.innerWidth > 768);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showPeriodMenu, setShowPeriodMenu] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [periodSwitching, setPeriodSwitching] = useState(false);
  const [showReminderMenu, setShowReminderMenu] = useState(false);
  const [reminders, setReminders] = useState([]);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [supportUnread, setSupportUnread] = useState(0);

  // Destek talepleri okunmamış polling (tenant + vendor)
  useEffect(() => {
    if (!user) return;
    const endpoint = company?.companyType === 'vendor' ? '/vendor/tickets-unread-count' : '/support/unread-count';
    let cancelled = false;
    const pull = async () => {
      try { const r = await api.get(endpoint); if (!cancelled && r.data.success) setSupportUnread(r.data.data.count || 0); }
      catch (_) {}
    };
    pull();
    const iv = setInterval(() => { if (!document.hidden) pull(); }, 20000);
    const onVis = () => { if (!document.hidden) pull(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { cancelled = true; clearInterval(iv); document.removeEventListener('visibilitychange', onVis); };
  }, [user, company?.companyType]);

  useEffect(() => {
    if (!user) return;
    api.get('/fiscal-periods').then(r => {
      if (r.data.success) setPeriods(r.data.data || []);
    }).catch(() => {});
  }, [user, activePeriod?.id]);

  // Randevu hatırlatmaları + okunmamış mesajlar — 15 sn poll, tab focus / visible olunca anında.
  useEffect(() => {
    if (!user) return;
    let stopped = false;
    const fetchAll = async () => {
      if (stopped) return;
      try {
        const r = await api.get('/appointments/reminders/pending');
        if (r.data.success) setReminders(r.data.data.items || []);
      } catch {}
      try {
        const r = await api.get('/messages/unread');
        if (r.data.success) setUnreadMessages(r.data.data.items || []);
      } catch {}
      try {
        const r = await api.get('/approvals/pending');
        if (r.data.success) setPendingApprovals(r.data.data || []);
      } catch {}
      try {
        const r = await api.get('/notifications', { params: { box: 'unread', limit: 20 } });
        if (r.data.success) setNotifications(r.data.data || []);
      } catch {}
    };
    fetchAll();
    const t = setInterval(fetchAll, 5000);
    const onVisibility = () => { if (document.visibilityState === 'visible') fetchAll(); };
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', fetchAll);
    return () => {
      stopped = true;
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', fetchAll);
    };
  }, [user]);

  // Sekme başlığında bekleyen sayı (randevu + mesaj + onay)
  useEffect(() => {
    const total = reminders.length + unreadMessages.length + pendingApprovals.length + notifications.length;
    const baseTitle = 'Hent ERP';
    document.title = total > 0 ? `(${total}) ${baseTitle}` : baseTitle;
  }, [reminders.length, unreadMessages.length, pendingApprovals.length, notifications.length]);

  // Native push bildirimi — her yeni randevu/mesaj için ayrı bildirim, tıklanca ilgili sayfaya gider.
  // İlk yüklemede mevcut bildirimleri "yeni" olarak sayma — sadece sonradan gelenleri göster.
  const prevReminderIdsRef = React.useRef(null);
  const prevMessageIdsRef  = React.useRef(null);
  const prevApprovalIdsRef = React.useRef(null);

  const showNotif = (title, options, onClick) => {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;
    try {
      const n = new Notification(title, options);
      if (onClick) n.onclick = (e) => { e.preventDefault(); window.focus(); onClick(); n.close(); };
      // 12 sn sonra otomatik kapansın (mobil tarayıcı default'a bırakır, masaüstünde kapatır)
      setTimeout(() => { try { n.close(); } catch {} }, 12000);
    } catch {}
  };

  useEffect(() => {
    const curReminderIds = new Set(reminders.map(r => r.reminder_id));
    if (prevReminderIdsRef.current === null) {
      prevReminderIdsRef.current = curReminderIds; // ilk render — gösterme
    } else {
      reminders.forEach(r => {
        if (prevReminderIdsRef.current.has(r.reminder_id)) return;
        const subtitleParts = [];
        if (r.start_at) subtitleParts.push(new Date(r.start_at).toLocaleString('tr-TR', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' }));
        if (r.account_title) subtitleParts.push(r.account_title);
        if (r.location) subtitleParts.push('📍 ' + r.location);
        showNotif('🗓 Randevu: ' + r.title, {
          body: subtitleParts.join(' · '),
          tag: 'reminder-' + r.reminder_id,
          requireInteraction: false,
          silent: false,
        }, () => { navigate('appointments'); });
      });
      prevReminderIdsRef.current = curReminderIds;
    }
  }, [reminders]);

  useEffect(() => {
    const curMessageIds = new Set(unreadMessages.map(m => m.id));
    if (prevMessageIdsRef.current === null) {
      prevMessageIdsRef.current = curMessageIds;
    } else {
      unreadMessages.forEach(m => {
        if (prevMessageIdsRef.current.has(m.id)) return;
        const sender = m.sender_name || m.sender_username || 'Bilinmeyen';
        const isBroadcast = !m.recipient_id;
        const title = (isBroadcast ? '📢 ' : '💬 ') + sender + (isBroadcast ? ' (Herkese)' : '');
        const body = m.body
          ? m.body.replace(/\s+/g, ' ').slice(0, 140)
          : (m.attachment_url ? '📷 Resim' : '');
        showNotif(title, {
          body,
          tag: 'msg-' + m.id,
          requireInteraction: false,
          silent: false,
        }, () => {
          const target = m.recipient_id ? m.sender_id : 'broadcast';
          try { localStorage.setItem('msgs_open_with', target); } catch {}
          navigate('messages');
        });
      });
      prevMessageIdsRef.current = curMessageIds;
    }
  }, [unreadMessages]);

  // Yeni gelen onay belgeleri için push bildirim
  useEffect(() => {
    const curApprovalIds = new Set(pendingApprovals.map(a => a.id));
    if (prevApprovalIdsRef.current === null) {
      prevApprovalIdsRef.current = curApprovalIds; // ilk render — gösterme
    } else {
      pendingApprovals.forEach(a => {
        if (prevApprovalIdsRef.current.has(a.id)) return;
        const moduleLabels = { invoice: 'Fatura', waybill: 'İrsaliye', order: 'Sipariş', quote: 'Teklif' };
        const dirLabels    = { sales: 'Satış', purchase: 'Alış' };
        const title = '✓ Yeni Onay Bekliyor: ' + (moduleLabels[a.module] || a.module) + ' / ' + (dirLabels[a.direction] || a.direction);
        const parts = [];
        if (a.document_number) parts.push(a.document_number);
        if (a.account_title)   parts.push(a.account_title);
        if (a.total_amount)    parts.push(parseFloat(a.total_amount).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL');
        showNotif(title, {
          body: parts.join(' · ') || (a.hierarchy_name || ''),
          tag: 'approval-' + a.id,
          requireInteraction: false,
          silent: false,
        }, () => { navigate('pending-approvals'); });
      });
      prevApprovalIdsRef.current = curApprovalIds;
    }
  }, [pendingApprovals]);

  // İlk girişte tarayıcı bildirim izni iste (sadece bir kez, default durumda)
  useEffect(() => {
    if (!user) return;
    if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default') {
      // Sayfa yüklendikten 3sn sonra sor (UX: anında popup spam gibi olmasın)
      const t = setTimeout(() => { try { Notification.requestPermission(); } catch {} }, 3000);
      return () => clearTimeout(t);
    }
  }, [user]);

  const dismissReminder = async (rid) => {
    try {
      await api.post('/appointments/reminders/' + rid + '/dismiss');
      setReminders(prev => prev.filter(r => r.reminder_id !== rid));
    } catch (e) { /* sessiz */ }
  };

  const dismissMessage = async (mid) => {
    try {
      await api.post('/messages/' + mid + '/read');
      setUnreadMessages(prev => prev.filter(m => m.id !== mid));
    } catch (e) { /* sessiz */ }
  };

  const openReminderAppointment = () => {
    setShowReminderMenu(false);
    navigate('appointments');
  };

  const openMessagePage = (mid, m) => {
    setShowReminderMenu(false);
    if (mid) dismissMessage(mid);
    // Deep-link: çan'daki mesaja tıklayınca o thread otomatik açılsın
    if (m) {
      const target = m.recipient_id ? m.sender_id : 'broadcast';
      try { localStorage.setItem('msgs_open_with', target); } catch {}
    }
    navigate('messages');
  };

  const fmtRelative = (d) => {
    if (!d) return '';
    const diff = (Date.now() - new Date(d).getTime()) / 1000;
    if (diff < 60) return 'şimdi';
    if (diff < 3600) return Math.floor(diff / 60) + ' dk önce';
    if (diff < 86400) return Math.floor(diff / 3600) + ' saat önce';
    return Math.floor(diff / 86400) + ' gün önce';
  };

  const fmtRemTime = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
  };

  const handleSelectPeriod = async (pid) => {
    if (pid === activePeriod?.id) { setShowPeriodMenu(false); return; }
    setPeriodSwitching(true);
    const r = await selectPeriod(pid);
    setPeriodSwitching(false);
    setShowPeriodMenu(false);
    if (!r.success) alert(r.message || 'Dönem değiştirilemedi');
  };
  const [bankMenuOpen, setBankMenuOpen] = useState(false);
  const [cashMenuOpen, setCashMenuOpen] = useState(false);
  const [salesMenuOpen, setSalesMenuOpen] = useState(false);
  const [purchaseMenuOpen, setPurchaseMenuOpen] = useState(false);
  const [programMenuOpen, setProgramMenuOpen] = useState(false);
  const [eklentilerMenuOpen, setEklentilerMenuOpen] = useState(false);
  const [vendorMenuOpen, setVendorMenuOpen] = useState(false);
  const [cariMenuOpen, setCariMenuOpen] = useState(false);
  const [salesModuleOpen, setSalesModuleOpen] = useState(false);
  const [crmModuleOpen, setCrmModuleOpen] = useState(false);
  const [ecomModuleOpen, setEcomModuleOpen] = useState(false);
  const [retailMenuOpen, setRetailMenuOpen] = useState(false);
  const [purchaseModuleOpen, setPurchaseModuleOpen] = useState(false);
  const [approvalsMenuOpen, setApprovalsMenuOpen] = useState(false);
  const [cekMenuOpen, setCekMenuOpen] = useState(false);
  const [muhasebeMenuOpen, setMuhasebeMenuOpen] = useState(false);
  const [stokMenuOpen, setStokMenuOpen] = useState(false);
  const [personelMenuOpen, setPersonelMenuOpen] = useState(false);
  const [reportsMenuOpen, setReportsMenuOpen] = useState(false);
  const [stockReportsOpen, setStockReportsOpen] = useState(false);
  const [quotesMenuOpen, setQuotesMenuOpen] = useState(false);
  const [ordersMenuOpen, setOrdersMenuOpen] = useState(false);
  const [waybillsMenuOpen, setWaybillsMenuOpen] = useState(false);
  const [senetMenuOpen, setSenetMenuOpen] = useState(false);
  const [ebelgeMenuOpen, setEbelgeMenuOpen] = useState(false);
  const [menuSearch, setMenuSearch] = useState('');
  const [cmdkOpen, setCmdkOpen] = useState(false);
  const [kbdHelpOpen, setKbdHelpOpen] = useState(false);
  const [pushSubscribed, setPushSubscribed] = useState(false);
  const [pushBusy, setPushBusy] = useState(false);

  // Push subscription durumunu çek (mount + user değişince)
  useEffect(() => {
    if (!user) return;
    isPushSubscribed().then(setPushSubscribed);
  }, [user]);

  const togglePush = async () => {
    if (pushBusy) return;
    if (!supportsPush()) { toast.error('Bu tarayıcı push bildirim desteklemiyor'); return; }
    setPushBusy(true);
    try {
      if (pushSubscribed) {
        const r = await unsubscribeFromPush();
        if (r.ok) { setPushSubscribed(false); toast.success('Push bildirim kapatıldı'); }
        else { toast.error('Kapatılamadı'); }
      } else {
        const perm = getPermissionStatus();
        if (perm === 'denied') {
          toast.error('Tarayıcı bildirim iznini engellemiş. Tarayıcı ayarlarından açın.');
          setPushBusy(false);
          return;
        }
        const r = await subscribeToPush();
        if (r.ok) {
          setPushSubscribed(true);
          toast.success('Push bildirim açıldı 🔔');
          // Test push gönder
          setTimeout(() => sendTestPush().catch(() => {}), 800);
        } else if (r.reason === 'denied') {
          toast.error('İzin reddedildi');
        } else if (r.reason === 'unsupported') {
          toast.error('Tarayıcı desteklemiyor');
        } else if (r.reason === 'no-vapid') {
          toast.error('Sunucuda VAPID yapılandırılmamış');
        } else {
          toast.error('Kayıt başarısız: ' + (r.message || r.reason));
        }
      }
    } finally { setPushBusy(false); }
  };

  // Global klavye kısayolları: Ctrl/Cmd+K = palette, ? = yardım
  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        setCmdkOpen(o => !o);
        return;
      }
      // "?" tuşu — input/textarea/contenteditable içinde DEĞİLse aç
      if (e.key === '?' && !e.ctrlKey && !e.metaKey && !e.altKey) {
        const tag = (e.target.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
        e.preventDefault();
        setKbdHelpOpen(o => !o);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const isMobile = () => window.innerWidth <= 768;

  const navigate = (page, recordId = null, opts = {}) => {
    setActivePage(page);
    setDeepLink(recordId ? { page, recordId, viewOnly: !!opts.viewOnly } : null);
    // URL'i de güncelle — tarayıcı geri/ileri çalışsın + link paylaşılabilsin
    const targetPath = pageToPath(page, recordId);
    if (location.pathname !== targetPath) routerNav(targetPath, opts.replace ? { replace: true } : undefined);
    if (page === 'bankislemleri' || page === 'bankaccounts' || page.startsWith('bank-') || page === 'expense-cards') setBankMenuOpen(true);
    if (page === 'kasaislemleri' || page.startsWith('cash-') || page === 'cashregisters' || page === 'cash-virman' || page === 'expense-vouchers' || page === 'expense-categories') setCashMenuOpen(true);
    if (page === 'satisiade' || page === 'sales' || page === 'sales-returns') setSalesMenuOpen(true);
    if (page === 'alisiade'  || page === 'purchases' || page === 'purchases-returns') setPurchaseMenuOpen(true);
    if (page === 'programtanimlari' || page === 'settings' || page === 'warehouses' || page === 'cashdef' || page === 'auditlog' || page === 'platformkargo' || page === 'fiscalperiods' || page === 'users' || page === 'roles' || page === 'pricedefinitions') setProgramMenuOpen(true);
    if (page === 'eklentiler' || page === 'pergola-calculator' || page === 'pergola-templates') setEklentilerMenuOpen(true);
    if (page === 'cariislemleri' || page === 'accounts' || page.startsWith('cari-')) setCariMenuOpen(true);
    if (page === 'quotes' || page.startsWith('quotes-')) setQuotesMenuOpen(true);
    if (page === 'orders' || page.startsWith('orders-')) setOrdersMenuOpen(true);
    if (page === 'waybills' || page.startsWith('waybills-')) setWaybillsMenuOpen(true);
    if (page === 'cekislemleri' || page.startsWith('cek-')) setCekMenuOpen(true);
    if (page === 'senetislemleri' || page.startsWith('senet-')) setSenetMenuOpen(true);
    // Satış / Satın Alma Modülü — açık olduğu sayfalarda otomatik aç
    if (page === 'satismodulu'     || page === 'sales' || page === 'sales-returns' || page === 'quotes-outgoing' || page === 'orders-incoming' || page === 'waybills-sales' || page === 'waybills-sales-returns') setSalesModuleOpen(true);
    if (page === 'crmmodulu' || page === 'crm-pipeline' || page === 'lead-form-embed') setCrmModuleOpen(true);
    if (page === 'ecommodulu' || page === 'ecom-orders' || page === 'ecom-catalog-embed') setEcomModuleOpen(true);
    if (page === 'satinalmamodulu' || page === 'purchases' || page === 'purchases-returns' || page === 'quotes-incoming' || page === 'orders-outgoing' || page === 'waybills-purchase' || page === 'waybills-purchase-returns') setPurchaseModuleOpen(true);
    if (page === 'belgeonaylari'   || page === 'pending-approvals' || page === 'approved-documents') setApprovalsMenuOpen(true);
    if (page === 'ebelgeyonetimi' || page.startsWith('ebelge-')) setEbelgeMenuOpen(true);
    if (page === 'accounting' || page.startsWith('acc-')) setMuhasebeMenuOpen(true);
    if (page === 'stokislemleri' || page === 'stocks' || page === 'stockseries' || page === 'colorsizewizard' || page === 'warehouse-transfers' || page === 'stock-counts' || page === 'stock-count-surplus' || page === 'stock-count-deficit' || page === 'stock-waste') setStokMenuOpen(true);
    if (page === 'personelislemleri' || page === 'personnel' || page === 'plasiyerroutes' || page === 'plasiyerdaily' || page === 'commissions' || page === 'commission-tiers' || page === 'personnel-borc' || page === 'personnel-alacak') setPersonelMenuOpen(true);
    if (page === 'reports' || page.startsWith('reports-') || page === 'stock-labels' || page === 'label-templates' || page === 'label-designer') setReportsMenuOpen(true);
    if (page === 'stock-labels' || page === 'label-templates' || page === 'label-designer') setStockReportsOpen(true);
    if (isMobile()) setSidebarOpen(false);
  };

  const pageTitles = {
    dashboard: 'Ana Sayfa', stocks: 'Stok / Ürünler', accounts: 'Cari Hesaplar',
    stokislemleri: 'Stok İşlemleri', stockseries: 'Stok Seri Tanımları', colorsizewizard: 'Renk / Beden Sihirbazı',
    personelislemleri: 'Personel İşlemleri', plasiyerroutes: 'Plasiyer Rotaları', plasiyerdaily: 'Günlük Saha Ziyaretleri',
    commissions: 'Prim / Hakediş Raporu',
    'commission-tiers': 'Prim Kademeleri (Tier)',
    'personnel-alacak': 'Personel Alacak Dekontu',
    'personnel-borc':   'Personel Borç Dekontu',
    cariislemleri: 'Cari İşlemler',
    crmmodulu:     'CRM Modülü',
    ecommodulu:    'E-Ticaret Modülü',
    'cari-acilis': 'Cari Açılış Fişi',
    'cari-borc':   'Cari Borç Dekontu',
    'cari-alacak': 'Cari Alacak Dekontu',
    'cari-virman': 'Cari Virman Dekontu',
    'cari-tahsilat': 'Cari Tahsilat Makbuzu',
    'cari-tediye':   'Cari Tediye Makbuzu',
    cekislemleri: 'Çek-Senet İşlemleri',
    'cek-portfoy': 'Çek Kartı (Alınan)',
    'cek-verilen': 'Çek Kartı (Verilen)',
    'senet-portfoy': 'Senet Kartı (Alınan)',
    'senet-verilen': 'Senet Kartı (Verilen)',
    satisiade: 'Satış / İade Faturaları', sales: 'Satış Faturası', 'sales-returns': 'Satış İade Faturası',
    alisiade: 'Alış / İade Faturaları', purchases: 'Alış Faturası', 'purchases-returns': 'Alış İade Faturası',
    warehouses: 'Depo Tanıtım Kartı', personnel: 'Personel',
    exchange: 'Kur Takibi', settings: 'Ayarlar',
    programtanimlari: 'Program Tanımları',
    campaigns: 'Kampanyalar',
    platformkargo: 'Platform / Kargo Tanımları',
    bankislemleri: 'Banka İşlemleri', bankaccounts: 'Banka Hesapları',
    kasaislemleri: 'Kasa İşlemleri', cashregisters: 'Kasa Hareketleri',
    'cash-acilis': 'Kasa Açılış Fişi', 'cash-virman': 'Kasa Virman Dekontu', cashdef: 'Kasa Tanıtım Kartı',
    'expense-vouchers': 'Gider Fişleri',
    'expense-categories': 'Gider Masraf Kartı',
    'warehouse-transfers': 'Depo Nakil Fişi',
    'stock-counts': 'Stok Sayım',
    'stock-count-surplus': 'Sayım Fazlası Fişleri',
    'stock-count-deficit': 'Sayım Eksiği Fişleri',
    'stock-waste': 'Fire Fişleri',
    'retail-hub': 'Perakende Mağaza',
    'expense-cards': 'Firma Kredi Kartları',
    'bank-acilis': 'Banka Açılış Fişi', 'bank-alacak': 'Banka Alacak Dekontu',
    'bank-borc': 'Banka Borç Dekontu', 'bank-virman': 'Banka Virman Dekontu',
    'bank-pos': 'Banka POS Kartları',
    'bank-pos-slips': 'POS Slip Tahsilat',
    'cari-vouchers': 'Alış Veriş Çekleri',
    auditlog: 'İşlem Geçmişi (LOG)',
    fiscalperiods: 'Çalışma Dönemleri',
    users: 'Kullanıcılar',
    roles: 'Roller ve İzinler',
    subscription: 'Aboneliğim',
    pricedefinitions: 'Fiyat Tanımları',
    accounting: 'Muhasebe',
    'acc-chart': 'Hesap Planı (TDHP)',
    'acc-mappings': 'Hesap Eşleme Tablosu',
    appointments: 'Randevu / Ajanda',
    messages: 'Mesajlar',
    'reports-stocks':    'Stok Raporları',
    'reports-accounts':  'Cari Raporları',
    'quotes-incoming':   'Alınan Teklifler',
    'quotes-outgoing':   'Verilen Teklifler',
    'orders-incoming':   'Alınan Siparişler',
    'orders-outgoing':   'Verilen Siparişler',
    'waybills-purchase': 'Alış İrsaliyesi',
    'waybills-sales':    'Satış İrsaliyesi',
    'reports-banks':     'Banka Raporları',
    'reports-personnel': 'Personel Raporları',
    'reports-invoices':  'Fatura Raporları',
    'stock-labels':      'Barkod Etiket Dökümü',
    'label-templates':   'Etiket Şablonları',
    'label-designer':    'Etiket Tasarım',
  };

  const initials = (name) => name ? name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0,2) : '?';
  const roleName = (r) => r ? t('role.' + r, { defaultValue: r }) : '';

  const isAdmin = user?.role === 'admin';
  // Yardımcı: izin gerekiyorsa kontrol et, gerektirmiyorsa göster
  const canSee = (perm) => !perm || isAdmin || hasPermission(perm);

  const bankChildItems = [
    { key: 'bankaccounts',   label: 'Banka Hesapları',      icon: 'bank',        perm: 'bank.view' },
    { key: 'bank-pos',       label: 'Banka POS Kartları',   icon: 'credit-card', perm: 'pos.view' },
    { key: 'bank-pos-slips', label: 'POS Slip Tahsilat',    icon: 'credit-card', perm: 'pos.view' },
    { key: 'expense-cards',  label: 'Firma Kredi Kartları', icon: 'credit-card', perm: 'expense_card.view' },
    { key: 'bank-acilis',    label: 'Banka Açılış Fişi',    icon: 'receipt',     perm: 'bank.view' },
    { key: 'bank-alacak',    label: 'Banka Alacak Dekontu', icon: 'receipt',     perm: 'bank.view' },
    { key: 'bank-borc',      label: 'Banka Borç Dekontu',   icon: 'receipt',     perm: 'bank.view' },
    { key: 'bank-virman',    label: 'Banka Virman Dekontu', icon: 'receipt',     perm: 'bank.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const cashChildItems = [
    { key: 'cashregisters',      label: 'Kasa Hareketleri',     icon: 'receipt', perm: 'cash.view' },
    { key: 'cash-acilis',        label: 'Kasa Açılış Fişi',     icon: 'receipt', perm: 'cash.view' },
    { key: 'cash-virman',        label: 'Kasa Virman Dekontu',  icon: 'receipt', perm: 'cash.view' },
    { key: 'expense-vouchers',   label: 'Gider Fişleri',        icon: 'receipt', perm: 'expense_voucher.view' },
    { key: 'expense-categories', label: 'Gider Masraf Kartı',   icon: 'receipt', perm: 'expense_voucher.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const salesChildItems = [
    { key: 'sales',         label: 'Satış Faturası',      icon: 'trending-up', perm: 'invoices.view' },
    { key: 'sales-returns', label: 'Satış İade Faturası', icon: 'rotate-ccw',  perm: 'invoices.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const purchaseChildItems = [
    { key: 'purchases',         label: 'Alış Faturası',      icon: 'trending-down', perm: 'invoices.view' },
    { key: 'purchases-returns', label: 'Alış İade Faturası', icon: 'rotate-ccw',    perm: 'invoices.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const cariChildItems = [
    { key: 'accounts',          label: 'Cari Hesaplar',         icon: 'users',     perm: 'accounts.view' },
    { key: 'prospect-accounts', label: 'Potansiyel Cariler',    icon: 'user',      perm: 'prospect_accounts.view' },
    { key: 'projects',          label: 'Projeler',              icon: 'briefcase', perm: 'accounts.view' },
    { key: 'cari-tahsilat',  label: 'Cari Tahsilat Makbuzu', icon: 'receipt', perm: 'cari_receipts.view' },
    { key: 'cari-tediye',    label: 'Cari Tediye Makbuzu',   icon: 'receipt', perm: 'cari_receipts.view' },
    { key: 'cari-vouchers',  label: 'Alış Veriş Çekleri',    icon: 'file-text', perm: 'shopping_vouchers.view' },
    { key: 'cari-acilis',    label: 'Cari Açılış Fişi',      icon: 'receipt', perm: 'accounts.view' },
    { key: 'cari-borc',      label: 'Cari Borç Dekontu',     icon: 'receipt', perm: 'accounts.view' },
    { key: 'cari-alacak',    label: 'Cari Alacak Dekontu',   icon: 'receipt', perm: 'accounts.view' },
    { key: 'cari-virman',    label: 'Cari Virman Dekontu',   icon: 'receipt', perm: 'accounts.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // CRM Modülü — pipeline + lead capture (top-level menü)
  const crmModuleChildItems = [
    { key: 'crm-pipeline',    label: 'CRM Pipeline',  icon: 'kanban',   perm: 'prospect_accounts.view' },
    { key: 'lead-form-embed', label: 'Web Lead Form', icon: 'sparkles', perm: 'prospect_accounts.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // E-Ticaret Modülü — siparişler + katalog kodu (top-level menü)
  const ecomModuleChildItems = [
    { key: 'ecom-orders',        label: 'E-Ticaret Siparişleri', icon: 'cart',     perm: 'accounts.view' },
    { key: 'ecom-catalog-embed', label: 'Katalog Kodu',          icon: 'sparkles', perm: 'accounts.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // Satış Modülü — Verilen Teklif → Alınan Sipariş → İrsaliye → Fatura akışı (top-level menü)
  const salesModuleChildItems = [
    { key: 'quotes-outgoing',         label: 'Verilen Teklifler',      icon: 'file-text',     perm: 'quotes.view' },
    { key: 'orders-incoming',         label: 'Alınan Siparişler',      icon: 'file-text',     perm: 'accounts.view' },
    { key: 'waybills-sales',          label: 'Satış İrsaliyesi',       icon: 'receipt',       perm: 'accounts.view' },
    { key: 'waybills-sales-returns',  label: 'Satış İade İrsaliyesi',  icon: 'rotate-ccw',    perm: 'accounts.view' },
    { key: 'sales',                   label: 'Satış Faturası',         icon: 'trending-up',   perm: 'invoices.view' },
    { key: 'sales-returns',           label: 'Satış İade Faturası',    icon: 'rotate-ccw',    perm: 'invoices.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // Perakende İşlemler — POS / hızlı satış akışı
  const retailModuleChildItems = [
    { key: 'retail-sales',     label: 'Perakende Satış',     icon: 'shopping-cart', perm: 'invoices.create' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // Belge Onayları — onay hiyerarşisi sürecindeki belgeler
  const approvalsChildItems = [
    { key: 'pending-approvals',  label: 'Bekleyen Onaylar',    icon: 'clock',  enabled: true, badge: pendingApprovals.length > 0 ? pendingApprovals.length : null },
    { key: 'approved-documents', label: 'Onaylanan Belgeler',  icon: 'check',  enabled: true },
  ];

  // Satın Alma Modülü — Alınan Teklif → Verilen Sipariş → İrsaliye → Fatura akışı (top-level menü)
  const purchaseModuleChildItems = [
    { key: 'rfq',                       label: 'RFQ (Toplu Teklif)',   icon: 'sparkles',      perm: 'quotes.view' },
    { key: 'quotes-incoming',           label: 'Alınan Teklifler',     icon: 'file-text',     perm: 'quotes.view' },
    { key: 'reorder-suggestions',       label: 'Sipariş Önerileri',    icon: 'trending-up',   perm: 'stocks.view' },
    { key: 'orders-outgoing',           label: 'Verilen Siparişler',   icon: 'file-text',     perm: 'accounts.view' },
    { key: 'waybills-purchase',         label: 'Alış İrsaliyesi',      icon: 'receipt',       perm: 'accounts.view' },
    { key: 'waybills-purchase-returns', label: 'Alış İade İrsaliyesi', icon: 'rotate-ccw',    perm: 'accounts.view' },
    { key: 'purchases',                 label: 'Alış Faturası',        icon: 'trending-down', perm: 'invoices.view' },
    { key: 'purchases-returns',         label: 'Alış İade Faturası',   icon: 'rotate-ccw',    perm: 'invoices.view' },
    { key: 'babs-report',               label: 'BA / BS Formu',        icon: 'file-text',     perm: 'invoices.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const quotesChildItems = [
    { key: 'quotes-incoming', label: 'Alınan Teklifler',  icon: 'file-text', perm: 'accounts.view' },
    { key: 'quotes-outgoing', label: 'Verilen Teklifler', icon: 'file-text', perm: 'accounts.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const ordersChildItems = [
    { key: 'orders-incoming', label: 'Alınan Siparişler',  icon: 'file-text', perm: 'accounts.view' },
    { key: 'orders-outgoing', label: 'Verilen Siparişler', icon: 'file-text', perm: 'accounts.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const waybillsChildItems = [
    { key: 'waybills-sales',            label: 'Satış İrsaliyesi',      icon: 'receipt', perm: 'accounts.view' },
    { key: 'waybills-sales-returns',    label: 'Satış İade İrsaliyesi', icon: 'rotate-ccw', perm: 'accounts.view' },
    { key: 'waybills-purchase',         label: 'Alış İrsaliyesi',       icon: 'receipt', perm: 'accounts.view' },
    { key: 'waybills-purchase-returns', label: 'Alış İade İrsaliyesi',  icon: 'rotate-ccw', perm: 'accounts.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const muhasebeChildItems = [
    { key: 'acc-chart',    label: 'Hesap Planı (TDHP)',    icon: 'file-text', perm: 'accounting.view' },
    { key: 'acc-mappings', label: 'Hesap Eşleme Tablosu',  icon: 'file-text', perm: 'accounting.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const cekChildItems = [
    { key: 'cek-portfoy',   label: 'Alınan Çekler',   icon: 'receipt', perm: 'check_note.view' },
    { key: 'cek-verilen',   label: 'Verilen Çekler',  icon: 'receipt', perm: 'check_note.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const senetChildItems = [
    { key: 'senet-portfoy', label: 'Alınan Senetler', icon: 'receipt', perm: 'check_note.view' },
    { key: 'senet-verilen', label: 'Verilen Senetler',icon: 'receipt', perm: 'check_note.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // E-Belge Yönetimi — gelen/giden e-fatura ve e-irsaliye yönetimi
  const ebelgeChildItems = [
    { key: 'ebelge-incoming-invoices', label: 'Gelen Fatura',    icon: 'trending-down', perm: 'e_documents.view' },
    { key: 'ebelge-outgoing-invoices', label: 'Giden Fatura',    icon: 'trending-up',   perm: 'e_documents.view' },
    { key: 'ebelge-incoming-waybills', label: 'Gelen İrsaliye',  icon: 'receipt',       perm: 'e_documents.view' },
    { key: 'ebelge-outgoing-waybills', label: 'Giden İrsaliye',  icon: 'receipt',       perm: 'e_documents.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const isSuperAdmin = user?.role === 'super_admin';
  // Vendor şirket kullanıcısı (HENT staff) — sadece vendor panelini görür, tenant modülleri yok
  const isVendorUser = company?.companyType === 'vendor';
  const vendorChildItems = (isSuperAdmin || isVendorUser) ? [
    { key: 'vendor-dashboard', label: 'Dashboard',          icon: 'activity' },
    { key: 'vendor-companies', label: 'Müşteri Firmalar',   icon: 'users' },
    { key: 'vendor-leads',     label: 'Lead\'ler & Pipeline', icon: 'trending-up' },
    { key: 'vendor-tickets',   label: 'Destek Talepleri',   icon: 'message', badge: supportUnread > 0 ? supportUnread : null },
    { key: 'vendor-messages',  label: 'Müşteri Mesajları',  icon: 'message' },
    { key: 'vendor-plans',     label: 'Abonelik Planları',  icon: 'pricing' },
    { key: 'vendor-payment-methods', label: 'Ödeme Yöntemleri', icon: 'dollar' },
    { key: 'vendor-reports',   label: 'Raporlar & Analitik', icon: 'bar-chart' },
    { key: 'vendor-team',      label: 'Kullanıcı Tanımları', icon: 'user-check' },
    { key: 'vendor-settings',  label: 'Vendor Ayarları',    icon: 'settings' },
    { key: 'balance-check',    label: 'Sistem Sağlığı (Bakiye)', icon: 'shield' },
  ].map(it => ({ ...it, enabled: true })) : [];

  // Eklenti / sektör paketleri — sadece tenant_modules'da aktif olanlar görünür
  const eklentilerChildItems = [
    ...(hasModule('pergola') ? [
      { key: 'pergola-calculator', label: 'Persan Maliyet Tabloları', icon: 'package',   perm: 'pergola.view' },
      { key: 'pergola-templates',  label: 'Persan Tablo Şablonları',  icon: 'file-text', perm: 'pergola.view' },
    ] : []),
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const programChildItems = [
    { key: 'settings',         label: 'Ayarlar',              icon: 'settings',  perm: 'settings.view' },
    { key: 'pricedefinitions', label: 'Fiyat Tanımları',      icon: 'dollar',    perm: 'settings.view' },
    { key: 'locations',        label: 'Yer Tanımları',        icon: 'package',   perm: 'settings.view' },
    { key: 'fiscalperiods',    label: 'Çalışma Dönemleri',    icon: 'file-text', adminOnly: true },
    { key: 'subscription',  label: 'Aboneliğim',             icon: 'dollar',    adminOnly: true },
    { key: 'users',         label: 'Kullanıcılar',           icon: 'user-check',adminOnly: true },
    { key: 'roles',         label: 'Roller ve İzinler',      icon: 'settings',  adminOnly: true },
    { key: 'warehouses',    label: 'Depo Tanıtım Kartı',     icon: 'warehouse', perm: 'warehouses.view' },
    { key: 'branches',      label: 'Şube Tanıtım Kartı',     icon: 'home',      perm: 'branches.view' },
    { key: 'cashdef',       label: 'Kasa Tanıtım Kartı',     icon: 'cash',      perm: 'cash.view' },
    { key: 'platformkargo', label: 'Platform / Kargo',       icon: 'package',   perm: 'settings.view' },
    { key: 'department-modules', label: 'Departman × Modül', icon: 'user-check', perm: 'settings.view' },
    { key: 'custom-fields', label: 'Özel Alanlar',           icon: 'sparkles',  adminOnly: true },
    { key: 'lost-reasons',  label: 'Kaybedilme Nedenleri',   icon: 'file-text', perm: 'prospect_accounts.view' },
    { key: 'sales-targets', label: 'Satış Hedefleri',        icon: 'trending-up', adminOnly: true },
    { key: 'campaigns',     label: 'Kampanyalar',            icon: 'sparkles',  perm: 'campaigns.view' },
    { key: 'auditlog',      label: 'İşlem Geçmişi (LOG)',    icon: 'file-text', perm: 'audit_log.view' },
  ].filter(it => it.adminOnly ? isAdmin : canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const stokChildItems = [
    { key: 'stocks',              label: 'Stok / Ürünler',         icon: 'package',   perm: 'stocks.view' },
    { key: 'stockseries',         label: 'Stok Seri Tanımları',    icon: 'file-text', perm: 'stocks.view' },
    { key: 'colorsizewizard',     label: 'Renk / Beden Sihirbazı', icon: 'settings',  perm: 'stocks.view' },
    { key: 'warehouse-transfers',   label: 'Depo Nakil Fişi',        icon: 'receipt', perm: 'warehouse_transfer.view' },
    { key: 'stock-counts',          label: 'Stok Sayım',             icon: 'receipt', perm: 'stock_count.view' },
    { key: 'stock-count-surplus',   label: 'Sayım Fazlası Fişleri',  icon: 'receipt', perm: 'stock_op_voucher.view' },
    { key: 'stock-count-deficit',   label: 'Sayım Eksiği Fişleri',   icon: 'receipt', perm: 'stock_op_voucher.view' },
    { key: 'stock-waste',           label: 'Fire Fişleri',           icon: 'receipt', perm: 'stock_op_voucher.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  const reportsChildItems = [
    {
      key: 'reports-stocks', label: 'Stok Raporları', icon: 'package', perm: 'reports.view',
      subItems: [
        { key: 'reports-stock-list', label: 'Stok Listesi',         icon: 'file-text', perm: 'reports.view' },
        { key: 'stock-labels',       label: 'Barkod Etiket Dökümü', icon: 'file-text', perm: 'reports.view' },
      ],
    },
    { key: 'reports-accounts',  label: 'Cari Raporları',     icon: 'users',       perm: 'reports.view' },
    { key: 'reports-banks',     label: 'Banka Raporları',    icon: 'bank',        perm: 'reports.view' },
    { key: 'reports-personnel', label: 'Personel Raporları', icon: 'user-check',  perm: 'reports.view' },
    { key: 'reports-invoices',  label: 'Fatura Raporları',   icon: 'file-text',   perm: 'reports.view' },
  ].filter(it => canSee(it.perm)).map(it => ({
    ...it,
    enabled: true,
    subItems: it.subItems ? it.subItems.filter(s => canSee(s.perm)) : undefined,
  }));

  const personelChildItems = [
    { key: 'personnel',         label: 'Personel',                  icon: 'user-check', perm: 'personnel.view' },
    { key: 'plasiyerroutes',    label: 'Plasiyer Rotaları',         icon: 'package',    perm: 'plasiyer.view' },
    { key: 'plasiyerdaily',     label: 'Günlük Saha Ziyaretleri',   icon: 'file-text',  perm: 'plasiyer.view' },
    { key: 'commissions',       label: 'Prim / Hakediş Raporu',     icon: 'dollar',     perm: 'commission.view' },
    { key: 'commission-tiers',  label: 'Prim Kademeleri (Tier)',    icon: 'percent',    perm: 'commission.edit' },
    { key: 'personnel-alacak',  label: 'Personel Alacak Dekontu',   icon: 'receipt',    perm: 'personnel.view' },
    { key: 'personnel-borc',    label: 'Personel Borç Dekontu',     icon: 'receipt',    perm: 'personnel.view' },
  ].filter(it => canSee(it.perm)).map(it => ({ ...it, enabled: true }));

  // Top-level menu — child grubu boş olan parent gizlenir; tek başına olanlar (exchange) izinle filtrelenir.
  // HENT (vendor) firmasında: tüm kullanıcılar normal ERP modüllerini görür; super_admin ayrıca vendor panelini de görür.
  const rawMenuItems = [
    { key: 'dashboard',        label: 'Ana Sayfa',                icon: 'home',          enabled: true },
    { key: 'retail-hub',       label: '🏪 Perakende Mağaza',      icon: 'shopping-cart', enabled: canSee('invoices.view') },
    { key: 'stokislemleri',    label: 'Stok Yönetimi',            icon: 'package',       hasChildren: true, childGroup: 'stok',     childCount: stokChildItems.length },
    { key: 'cariislemleri',    label: 'Cari Yönetimi',            icon: 'users',         hasChildren: true, childGroup: 'cari',     childCount: cariChildItems.length },
    { key: 'crmmodulu',        label: 'CRM Modülü',               icon: 'kanban',        hasChildren: true, childGroup: 'crm-module',      childCount: crmModuleChildItems.length },
    { key: 'satismodulu',      label: 'Satış Modülü',             icon: 'trending-up',   hasChildren: true, childGroup: 'sales-module',    childCount: salesModuleChildItems.length },
    { key: 'satinalmamodulu',  label: 'Satın Alma Modülü',        icon: 'trending-down', hasChildren: true, childGroup: 'purchase-module', childCount: purchaseModuleChildItems.length },
    { key: 'ecommodulu',       label: 'E-Ticaret Modülü',         icon: 'cart',          hasChildren: true, childGroup: 'ecom-module',     childCount: ecomModuleChildItems.length },
    { key: 'ebelgeyonetimi',   label: 'E-Belge Yönetimi',         icon: 'file-text',     hasChildren: true, childGroup: 'ebelge',   childCount: ebelgeChildItems.length },
    { key: 'bankislemleri',    label: 'Banka Yönetimi',           icon: 'bank',          hasChildren: true, childGroup: 'bank',     childCount: bankChildItems.length },
    { key: 'cekislemleri',     label: 'Çek Yönetimi',             icon: 'file-text',     hasChildren: true, childGroup: 'cek',      childCount: cekChildItems.length },
    { key: 'senetislemleri',   label: 'Senet Yönetimi',           icon: 'file-text',     hasChildren: true, childGroup: 'senet',    childCount: senetChildItems.length },
    { key: 'kasaislemleri',    label: 'Kasa Yönetimi',            icon: 'cash',          hasChildren: true, childGroup: 'kasa',     childCount: cashChildItems.length },
    { key: 'accounting',       label: 'Muhasebe Yönetimi',        icon: 'dollar',        hasChildren: true, childGroup: 'muhasebe', childCount: muhasebeChildItems.length },
    { key: 'reports',          label: 'Raporlar',                 icon: 'bar-chart',     hasChildren: true, childGroup: 'reports',  childCount: reportsChildItems.length },
    { key: 'personelislemleri',label: 'Personel Yönetimi',        icon: 'user-check',    hasChildren: true, childGroup: 'personel', childCount: personelChildItems.length },
    { key: 'appointments',     label: 'Randevu / Ajanda',         icon: 'calendar',      enabled: canSee('appointments.view') },
    ...(isVendorCompany ? [] : [{ key: 'belgeonaylari', label: 'Belge Onayları', icon: 'check', hasChildren: true, childGroup: 'approvals', childCount: approvalsChildItems.length, badge: pendingApprovals.length > 0 ? pendingApprovals.length : null }]),
    { key: 'messages',         label: 'Mesajlar',                 icon: 'message',       enabled: canSee('messages.view') },
    ...(isVendorCompany ? [] : [{ key: 'support', label: 'Destek', icon: 'message', enabled: true, badge: supportUnread > 0 ? supportUnread : null }]),
    ...(isVendorCompany ? [] : [{ key: 'ai-analysis', label: 'AI Veri Analizi', icon: 'sparkles', enabled: true }]),
    { key: 'exchange',         label: 'Kur Takibi',               icon: 'currency',      enabled: canSee('exchange.view') },
    { key: 'eklentiler',       label: 'Eklentiler',               icon: 'package',       hasChildren: true, childGroup: 'eklentiler', childCount: eklentilerChildItems.length },
    ...(isSuperAdmin ? [{ key: 'vendor', label: '🏢 Vendor Yönetimi', icon: 'briefcase', hasChildren: true, childGroup: 'vendor', childCount: vendorChildItems.length }] : []),
    { key: 'programtanimlari', label: 'Program Tanımları',        icon: 'settings',      hasChildren: true, childGroup: 'program',  childCount: programChildItems.length },
  ];
  const menuItems = rawMenuItems
    .map(it => ({
      ...it,
      enabled: it.hasChildren ? it.childCount > 0 : (it.enabled !== false),
    }))
    .filter(it => {
      // Çocuklu kategori → çocuğu olmayan gizlenir
      if (it.hasChildren) return it.childCount > 0;
      // Tek başına item → enabled=false placeholder'lar (purchases, reports vb.) görünür kalır
      // exchange admin değilse ve izin yoksa enabled=false döner → gizlemek için filtrele
      if (it.key === 'exchange') return it.enabled;
      if (it.key === 'appointments') return it.enabled;
      if (it.key === 'messages') return it.enabled;
      if (it.key === 'support') return it.enabled;
      return true;
    });

  // ── Menü arama ──
  const groupChildren = {
    bank: bankChildItems, kasa: cashChildItems,
    cari: cariChildItems, cek: cekChildItems, senet: senetChildItems,
    ebelge: ebelgeChildItems,
    muhasebe: muhasebeChildItems, program: programChildItems, stok: stokChildItems,
    personel: personelChildItems, reports: reportsChildItems,
    eklentiler: eklentilerChildItems,
    vendor: vendorChildItems,
    'sales-module':    salesModuleChildItems,
    'crm-module':      crmModuleChildItems,
    'ecom-module':     ecomModuleChildItems,
    'purchase-module': purchaseModuleChildItems,
    approvals:         approvalsChildItems,
  };
  const groupOpenState = {
    bank: bankMenuOpen, kasa: cashMenuOpen,
    cari: cariMenuOpen, cek: cekMenuOpen, senet: senetMenuOpen,
    ebelge: ebelgeMenuOpen,
    muhasebe: muhasebeMenuOpen, program: programMenuOpen, stok: stokMenuOpen,
    personel: personelMenuOpen, reports: reportsMenuOpen,
    eklentiler: eklentilerMenuOpen,
    vendor: vendorMenuOpen,
    'sales-module':    salesModuleOpen,
    'crm-module':      crmModuleOpen,
    'ecom-module':     ecomModuleOpen,
    'purchase-module': purchaseModuleOpen,
    approvals:         approvalsMenuOpen,
  };
  const searchQ = (menuSearch || '').trim().toLowerCase();
  const matchesSearch = (label) => !searchQ || (label || '').toLowerCase().includes(searchQ);
  const childrenForGroup = (g) => {
    const list = groupChildren[g] || [];
    if (!searchQ) return list;
    return list.filter(c => matchesSearch(c.label) || (c.subItems && c.subItems.some(s => matchesSearch(s.label))));
  };
  const isGroupExpanded = (g) => searchQ ? (childrenForGroup(g).length > 0) : !!groupOpenState[g];
  const filteredMenuItems = (isCashier ? menuItems.filter(it => it.key === 'retail-hub') : menuItems).filter(it => {
    if (!searchQ) return true;
    if (matchesSearch(it.label)) return true;
    if (it.childGroup && childrenForGroup(it.childGroup).length > 0) return true;
    return false;
  });

  const getIcon = (name) => {
    const icons = {
      home: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
      package: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>,
      users: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
      'trending-up': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
      'trending-down': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>,
      'file-text': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
      'credit-card': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="22" height="16" x="1" y="4" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>,
      'bank': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/></svg>,
      'cash': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/><circle cx="12" cy="15" r="2"/></svg>,
      receipt: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z"/><line x1="8" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="14" y2="14"/></svg>,
      dollar: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
      'bar-chart': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
      'warehouse': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
      'user-check': <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></svg>,
      currency: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v12M9 9h4.5a2.5 2.5 0 0 1 0 5H9a2.5 2.5 0 0 0 0 5H15"/></svg>,
      settings: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
      calendar: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
      message: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
      sparkles: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.9 5.6L19.5 10.5l-5.6 1.9L12 18l-1.9-5.6L4.5 10.5l5.6-1.9z"/><path d="M19 3v4M5 19v2M21 19v2"/></svg>,
      kanban: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="5" height="14" rx="1"/><rect x="10" y="3" width="5" height="9" rx="1"/><rect x="17" y="3" width="4" height="6" rx="1"/></svg>,
    };
    return icons[name] || icons.home;
  };

  const renderContent = () => {
    switch (activePage) {
      case 'stocks': return <StocksPage onNavigate={navigate} />;
      case 'stock-card-demo': return <StockCardDemoPage />;
      case 'retail-sales': return <RetailSalesPage />;
      case 'stockseries': return <StockSeriesPage />;
      case 'colorsizewizard': return <ColorSizeWizardPage />;
      case 'plasiyerroutes': return <PlasiyerRoutesPage />;
      case 'plasiyerdaily': return <PlasiyerDailyPage />;
      case 'commissions': return <CommissionReportPage />;
      case 'commission-tiers': return <CommissionTiersPage />;
      case 'personnel-alacak': return <PersonnelVoucherPage txType="credit" autoOpenId={deepLink?.page === 'personnel-alacak' ? deepLink.recordId : null} />;
      case 'personnel-borc':   return <PersonnelVoucherPage txType="debit"  autoOpenId={deepLink?.page === 'personnel-borc'   ? deepLink.recordId : null} />;
      case 'fiscalperiods':    return <FiscalPeriodsPage />;
      case 'users':            return <UsersPage />;
      case 'subscription':     return <SubscriptionPage />;
      case 'roles':            return <RolesPage />;
      case 'pricedefinitions': return <PriceDefinitionsPage />;
      case 'pergola-calculator': return <PergolaCalculatorPage />;
      case 'pergola-templates':  return <PergolaTemplatesPage />;
      case 'locations':        return <LocationsPage />;
      case 'accounts': return <AccountsPage onNavigate={navigate} />;
      case 'prospect-accounts': return <ProspectAccountsPage onNavigate={navigate} />;
      case 'crm-pipeline': return <CrmPipelinePage onNavigate={navigate} />;
      case 'custom-fields': return <CustomFieldsManagerPage />;
      case 'lead-form-embed': return <LeadFormEmbedPage />;
      case 'ecom-orders': return <EcomOrdersPage />;
      case 'ecom-catalog-embed': return <EcomCatalogEmbedPage />;
      case 'projects': return <ProjectsPage />;
      case 'lost-reasons': return <LostReasonsPage />;
      case 'sales-targets': return <SalesTargetsPage />;
      case 'babs-report': return <BABSReportPage />;
      case 'reorder-suggestions': return <ReorderSuggestionsPage onNavigate={navigate} />;
      case 'rfq': return <RfqPage onNavigate={navigate} />;
      case 'department-modules': return <DepartmentModulesPage />;
      case 'edocument-settings': return <EDocumentSettingsPage />;
      case 'ebelge-outgoing-invoices': return <EDocumentsListPage docGroup="invoice" title="Giden Faturalar" />;
      case 'ebelge-outgoing-waybills': return <EDocumentsListPage docGroup="waybill" title="Giden İrsaliyeler" />;
      case 'ebelge-incoming-invoices': return <EDocumentInboxPage docGroup="invoice" title="Gelen Faturalar" />;
      case 'ebelge-incoming-waybills': return <EDocumentInboxPage docGroup="waybill" title="Gelen İrsaliyeler" />;
      case 'vendor-dashboard':   return <VendorDashboardPage onNavigate={navigate} />;
      case 'vendor-companies':   return <VendorCompaniesPage onNavigate={navigate} />;
      case 'vendor-plans':       return <VendorPlansPage />;
      case 'vendor-messages':    return <VendorMessagesPage />;
      case 'vendor-customer-detail':
        return <VendorCustomerDetailPage companyId={deepLink?.recordId} onBack={() => navigate('vendor-companies')} />;
      case 'vendor-team':        return <VendorTeamPage />;
      case 'vendor-payment-methods': return <VendorPaymentMethodsPage />;
      case 'vendor-settings':    return <VendorSettingsPage />;
      case 'vendor-leads':       return <VendorLeadsPage />;
      case 'vendor-tickets':     return <VendorTicketsPage />;
      case 'vendor-reports':     return <VendorReportsPage />;
      case 'warehouses': return <WarehousesPage />;
      case 'branches': return <BranchesPage />;
      case 'campaigns': return <CampaignsPage onNavigate={navigate} />;
      case 'balance-check': return <BalanceCheckPage />;
      case 'sales': return <SalesInvoicePage mode="sales" autoOpenId={deepLink?.page === 'sales' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'sales' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'sales-returns': return <SalesInvoicePage mode="returns" autoOpenId={deepLink?.page === 'sales-returns' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'sales-returns' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'purchases': return <SalesInvoicePage mode="purchase" autoOpenId={deepLink?.page === 'purchases' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'purchases' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'purchases-returns': return <SalesInvoicePage mode="purchase-returns" autoOpenId={deepLink?.page === 'purchases-returns' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'purchases-returns' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'personnel': return <PersonnelPage onNavigate={navigate} />;
      case 'pending-approvals':  return <PendingApprovalsPage  onNavigate={navigate} />;
      case 'approved-documents': return <ApprovedDocumentsPage onNavigate={navigate} />;
      case 'exchange': return <ExchangePage />;
      case 'bankaccounts': return <BankAccountsPage onNavigate={navigate} />;
      case 'bank-acilis': return <BankVoucherPage txType="opening" autoOpenId={deepLink?.page === 'bank-acilis' ? deepLink.recordId : null} onNavigate={navigate} />;
      case 'bank-alacak': return <BankVoucherPage txType="credit"  autoOpenId={deepLink?.page === 'bank-alacak' ? deepLink.recordId : null} onNavigate={navigate} />;
      case 'bank-borc':   return <BankVoucherPage txType="debit"   autoOpenId={deepLink?.page === 'bank-borc'   ? deepLink.recordId : null} onNavigate={navigate} />;
      case 'bank-virman': return <BankVoucherPage txType="virman"  autoOpenId={deepLink?.page === 'bank-virman' ? deepLink.recordId : null} onNavigate={navigate} />;
      case 'bank-pos':       return <BankPosPage />;
      case 'bank-pos-slips': return <PosSlipsPage />;
      case 'cari-vouchers':  return <ShoppingVouchersPage onNavigate={navigate} />;
      case 'cari-acilis': return <CariVoucherPage txType="opening" autoOpenId={deepLink?.page === 'cari-acilis' ? deepLink.recordId : null} />;
      case 'cari-borc':   return <CariVoucherPage txType="debit"   autoOpenId={deepLink?.page === 'cari-borc'   ? deepLink.recordId : null} />;
      case 'cari-alacak': return <CariVoucherPage txType="credit"  autoOpenId={deepLink?.page === 'cari-alacak' ? deepLink.recordId : null} />;
      case 'cari-virman': return <CariVoucherPage txType="virman"  autoOpenId={deepLink?.page === 'cari-virman' ? deepLink.recordId : null} />;
      case 'cari-tahsilat': return <CariReceiptPage autoOpenId={deepLink?.page === 'cari-tahsilat' ? deepLink.recordId : null} />;
      case 'cari-tediye':   return <CariPaymentPage autoOpenId={deepLink?.page === 'cari-tediye'   ? deepLink.recordId : null} />;
      case 'cek-portfoy':   return <ChecksNotesPage docType="check" direction="incoming" onNavigate={navigate} autoOpenId={deepLink?.page === 'cek-portfoy'   ? deepLink.recordId : null} />;
      case 'cek-verilen':   return <ChecksNotesPage docType="check" direction="outgoing" onNavigate={navigate} autoOpenId={deepLink?.page === 'cek-verilen'   ? deepLink.recordId : null} />;
      case 'senet-portfoy': return <ChecksNotesPage docType="note"  direction="incoming" onNavigate={navigate} autoOpenId={deepLink?.page === 'senet-portfoy' ? deepLink.recordId : null} />;
      case 'senet-verilen': return <ChecksNotesPage docType="note"  direction="outgoing" onNavigate={navigate} autoOpenId={deepLink?.page === 'senet-verilen' ? deepLink.recordId : null} />;
      case 'cashregisters': return <CashMovementsPage />;
      case 'cash-acilis':   return <CashOpeningPage />;
      case 'cash-virman':   return <CashVirmanPage />;
      case 'expense-vouchers': return <ExpenseVouchersPage autoOpenId={deepLink?.page === 'expense-vouchers' ? deepLink.recordId : null} />;
      case 'expense-categories': return <ExpenseCategoriesPage onNavigate={navigate} />;
      case 'warehouse-transfers': return <WarehouseTransfersPage autoOpenId={deepLink?.page === 'warehouse-transfers' ? deepLink.recordId : null} />;
      case 'stock-counts': return <StockCountsPage onNavigate={navigate} autoOpenId={deepLink?.page === 'stock-counts' ? deepLink.recordId : null} />;
      case 'stock-count-surplus': return <StockOpVoucherPage voucherType="count_surplus" autoOpenId={deepLink?.page === 'stock-count-surplus' ? deepLink.recordId : null} />;
      case 'stock-count-deficit': return <StockOpVoucherPage voucherType="count_deficit" autoOpenId={deepLink?.page === 'stock-count-deficit' ? deepLink.recordId : null} />;
      case 'stock-waste':         return <StockOpVoucherPage voucherType="waste"          autoOpenId={deepLink?.page === 'stock-waste' ? deepLink.recordId : null} />;
      case 'retail-hub': return <RetailHubPage
        onNavigate={navigate}
        userName={user?.fullName || user?.full_name || user?.username}
        canSee={isCashier ? (() => true) : canSee}
        assignedWarehouseId={user?.defaultWarehouseId || null}
        assignedCashRegisterId={user?.defaultCashRegisterId || null}
        onLogout={logout}
        isCashier={isCashier}
      />;
      case 'expense-cards': return <FinancePage />;
      case 'cashdef':       return <CashRegistersPage />;
      case 'platformkargo': return <ProgramDefinitionsPage />;
      case 'auditlog':      return <AuditLogPage />;
      case 'acc-chart':     return <ChartOfAccountsPage />;
      case 'acc-mappings':  return <AccountingMappingsPage />;
      case 'appointments':  return <AppointmentsPage />;
      case 'messages':      return <MessagesPage />;
      case 'support':       return <SupportPage />;
      case 'reports-stocks':    return <StockReportsHub onNavigate={navigate} />;
      case 'reports-stock-list': return <StockListReportPage onNavigate={navigate} />;
      case 'report-designer':    return <ReportDesignerPage   onNavigate={navigate} />;
      case 'reports-accounts':  return <ReportsPlaceholder title="Cari Raporları" />;
      case 'quotes-incoming':   return <SalesInvoicePage mode="quote-incoming" autoOpenId={deepLink?.page === 'quotes-incoming' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'quotes-incoming' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'quotes-outgoing':   return <SalesInvoicePage mode="quote-outgoing" autoOpenId={deepLink?.page === 'quotes-outgoing' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'quotes-outgoing' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'orders-incoming':   return <SalesInvoicePage mode="order-incoming" autoOpenId={deepLink?.page === 'orders-incoming' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'orders-incoming' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'orders-outgoing':   return <SalesInvoicePage mode="order-outgoing" autoOpenId={deepLink?.page === 'orders-outgoing' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'orders-outgoing' && deepLink.viewOnly} onNavigate={navigate} />;
      case 'waybills-purchase':         return <SalesInvoicePage mode="waybill-purchase" autoOpenId={deepLink?.page === 'waybills-purchase' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'waybills-purchase' && deepLink.viewOnly} />;
      case 'waybills-purchase-returns': return <SalesInvoicePage mode="waybill-purchase-returns" autoOpenId={deepLink?.page === 'waybills-purchase-returns' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'waybills-purchase-returns' && deepLink.viewOnly} />;
      case 'waybills-sales-returns':    return <SalesInvoicePage mode="waybill-sales-returns" autoOpenId={deepLink?.page === 'waybills-sales-returns' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'waybills-sales-returns' && deepLink.viewOnly} />;
      case 'waybills-sales':    return <SalesInvoicePage mode="waybill-sales" autoOpenId={deepLink?.page === 'waybills-sales' ? deepLink.recordId : null} viewOnly={deepLink?.page === 'waybills-sales' && deepLink.viewOnly} />;
      case 'reports-banks':     return <ReportsPlaceholder title="Banka Raporları" />;
      case 'reports-personnel': return <ReportsPlaceholder title="Personel Raporları" />;
      case 'reports-invoices':  return <ReportsPlaceholder title="Fatura Raporları" />;
      case 'stock-labels':      return <StockLabelsPage onNavigate={navigate} />;
      case 'label-templates':   return <LabelTemplatesPage onNavigate={navigate} />;
      case 'label-designer':    return <LabelDesignerPage onNavigate={navigate} />;
      case 'settings': return <SettingsPage />;
      case 'print-templates': return <PrintTemplatesPage />;
      case 'ai-analysis': return <AiAnalysisPage />;
      default: return <DashboardContent onNavigate={setActivePage} />;
    }
  };

  return (
    <div className="mdi-layout" style={isImpersonating ? { paddingTop: 38, height: 'calc(100vh - 0px)' } : undefined}>
      {/* IMPERSONATION BANNER — super_admin başka tenant olarak girdiyse görünür */}
      {isImpersonating && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
          background: 'linear-gradient(90deg, #7c3aed 0%, #dc2626 100%)',
          color: '#fff', padding: '8px 16px',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
          fontSize: '0.82rem', fontWeight: 500,
          boxShadow: '0 2px 12px rgba(0,0,0,0.20)',
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
               style={{ animation: 'rotate 8s linear infinite' }}>
            <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/>
          </svg>
          <span>
            <b>Müşteri olarak giriş yapıldı:</b> {company?.name || 'Bilinmiyor'} ({company?.code})
            {impersonatedByInfo?.adminName && <span style={{ opacity: 0.85 }}> · {impersonatedByInfo.adminName}</span>}
          </span>
          <button onClick={endImpersonation} style={{
            background: 'rgba(255,255,255,0.20)', border: '1px solid rgba(255,255,255,0.35)',
            color: '#fff', padding: '4px 12px', borderRadius: 100,
            fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}>← Vendor paneline dön</button>
        </div>
      )}
      {/* SIDEBAR — kasiyer modunda gizli */}
      {!isCashier && <aside className={'sidebar' + (sidebarOpen ? ' open' : ' collapsed')}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-icon" style={{ background: 'transparent', boxShadow: 'none', padding: 0 }}>
              <img
                src="/logo.png"
                alt="Hent"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>
            {sidebarOpen && (
              <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                <span className="sidebar-logo-text">Hent</span>
                <span style={{ fontSize: '0.62rem', color: 'var(--text-tertiary)', fontWeight: 500, letterSpacing: '0.3px' }}>İşinizin Akıllı Merkezi</span>
              </div>
            )}
          </div>
        </div>

        {sidebarOpen && (
          <div style={{ padding: '8px 12px 6px', position: 'relative' }}>
            <input
              type="text"
              value={menuSearch}
              onChange={e => setMenuSearch(e.target.value)}
              placeholder="Menüde ara..."
              style={{
                width: '100%', padding: '7px 28px 7px 30px', borderRadius: 8,
                border: '1px solid var(--border-secondary)',
                background: 'var(--bg-secondary)', color: 'var(--text-primary)',
                fontSize: '0.82rem', outline: 'none', boxSizing: 'border-box',
              }}
            />
            <span style={{ position: 'absolute', left: 21, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)', pointerEvents: 'none', display: 'flex' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
            </span>
            {menuSearch && (
              <button
                onClick={() => setMenuSearch('')}
                title="Temizle"
                style={{ position: 'absolute', right: 18, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-tertiary)', padding: 2, display: 'flex' }}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            )}
          </div>
        )}

        <nav className="sidebar-nav">
          {filteredMenuItems.map((item) => (
            <div key={item.key} className={'sidebar-group'
              + (item.childGroup && isGroupExpanded(item.childGroup) ? ' expanded' : '')
              + (item.childGroup ? '' : ' standalone')}>
              <button
                className={'sidebar-item'
                  + (item.hasChildren ? ' parent' : '')
                  + (item.childGroup && isGroupExpanded(item.childGroup) ? ' expanded' : '')
                  + (activePage === item.key ? ' active' : '')
                  + (!item.enabled ? ' disabled' : '')
                  + (item.childGroup === 'bank'    && (activePage === 'bankaccounts' || activePage.startsWith('bank-')) ? ' active' : '')
                  + (item.childGroup === 'kasa'    && (activePage.startsWith('cash-') || activePage === 'cashregisters') ? ' active' : '')
                  + (item.childGroup === 'sales-module'    && (activePage === 'sales' || activePage === 'sales-returns' || activePage === 'quotes-outgoing' || activePage === 'orders-incoming' || activePage === 'waybills-sales' || activePage === 'waybills-sales-returns') ? ' active' : '')
                  + (item.childGroup === 'purchase-module' && (activePage === 'purchases' || activePage === 'purchases-returns' || activePage === 'quotes-incoming' || activePage === 'orders-outgoing' || activePage === 'waybills-purchase' || activePage === 'waybills-purchase-returns') ? ' active' : '')
                  + (item.childGroup === 'ebelge'  && activePage.startsWith('ebelge-') ? ' active' : '')
                  + (item.childGroup === 'cari'    && (activePage === 'accounts' || activePage.startsWith('cari-')) ? ' active' : '')
                  + (item.childGroup === 'cek'     && activePage.startsWith('cek-') ? ' active' : '')
                  + (item.childGroup === 'senet'   && activePage.startsWith('senet-') ? ' active' : '')
                  + (item.childGroup === 'muhasebe' && (activePage === 'accounting' || activePage.startsWith('acc-')) ? ' active' : '')
                  + (item.childGroup === 'program' && (activePage === 'settings' || activePage === 'warehouses' || activePage === 'cashdef' || activePage === 'auditlog' || activePage === 'platformkargo') ? ' active' : '')
                  + (item.childGroup === 'stok'    && (activePage === 'stocks' || activePage === 'stockseries' || activePage === 'colorsizewizard') ? ' active' : '')
                  + (item.childGroup === 'personel'&& (activePage === 'personnel' || activePage === 'plasiyerroutes' || activePage === 'plasiyerdaily' || activePage === 'commissions') ? ' active' : '')
                  + (item.childGroup === 'reports' && activePage.startsWith('reports-') ? ' active' : '')
                }
                onClick={() => {
                  if (!item.enabled) return;
                  if (item.childGroup === 'bank')    { setBankMenuOpen(o => !o); return; }
                  if (item.childGroup === 'kasa')    { setCashMenuOpen(o => !o); return; }
                  if (item.childGroup === 'cari')    { setCariMenuOpen(o => !o); return; }
                  if (item.childGroup === 'sales-module')    { setSalesModuleOpen(o => !o); return; }
                  if (item.childGroup === 'crm-module')      { setCrmModuleOpen(o => !o); return; }
                  if (item.childGroup === 'ecom-module')     { setEcomModuleOpen(o => !o); return; }
                  if (item.childGroup === 'purchase-module') { setPurchaseModuleOpen(o => !o); return; }
                  if (item.childGroup === 'approvals')       { setApprovalsMenuOpen(o => !o); return; }
                  if (item.childGroup === 'cek')     { setCekMenuOpen(o => !o); return; }
                  if (item.childGroup === 'senet')   { setSenetMenuOpen(o => !o); return; }
                  if (item.childGroup === 'ebelge')  { setEbelgeMenuOpen(o => !o); return; }
                  if (item.childGroup === 'muhasebe') { setMuhasebeMenuOpen(o => !o); return; }
                  if (item.childGroup === 'program') { setProgramMenuOpen(o => !o); return; }
                  if (item.childGroup === 'eklentiler') { setEklentilerMenuOpen(o => !o); return; }
                  if (item.childGroup === 'vendor') { setVendorMenuOpen(o => !o); return; }
                  if (item.childGroup === 'stok')    { setStokMenuOpen(o => !o); return; }
                  if (item.childGroup === 'personel'){ setPersonelMenuOpen(o => !o); return; }
                  if (item.childGroup === 'reports') { setReportsMenuOpen(o => !o); return; }
                  navigate(item.key);
                }}
                title={!sidebarOpen ? nl(item.label) : ''}
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
              >
                <span className="sidebar-icon">{getIcon(item.icon)}</span>
                {sidebarOpen && <span className="sidebar-label" style={{ flex: 1 }}>{nl(item.label)}</span>}
                {sidebarOpen && item.badge != null && (
                  <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 'var(--r-full)',
                    background: 'var(--danger)', color: '#fff', fontWeight: 700, marginRight: 4 }}>
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
                {sidebarOpen && item.childGroup && groupChildren[item.childGroup] && (
                  <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', marginRight: 2, lineHeight: 1 }}>
                    {isGroupExpanded(item.childGroup) ? '−' : '+'}
                  </span>
                )}
                {!item.enabled && sidebarOpen && <span className="sidebar-soon">{i18n.language?.startsWith('en') ? 'Soon' : 'Yakında'}</span>}
              </button>
              {item.childGroup && item.childGroup !== 'reports' && isGroupExpanded(item.childGroup) && childrenForGroup(item.childGroup).map(child => (
                <button key={child.key} className={'sidebar-item child' + (activePage === child.key ? ' active' : '')}
                  onClick={() => navigate(child.key)} title={!sidebarOpen ? nl(child.label) : ''}>
                  <span className="sidebar-icon">{getIcon(child.icon)}</span>
                  {sidebarOpen && <span className="sidebar-label" style={{ flex: 1 }}>{nl(child.label)}</span>}
                  {sidebarOpen && child.badge != null && (
                    <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 'var(--r-full)',
                      background: 'var(--danger)', color: '#fff', fontWeight: 700, marginLeft: 4 }}>
                      {child.badge > 99 ? '99+' : child.badge}
                    </span>
                  )}
                </button>
              ))}
              {item.childGroup === 'reports' && isGroupExpanded('reports') && childrenForGroup('reports').map(child => {
                const hasSubItems = child.subItems && child.subItems.length > 0;
                const subMatchedBySearch = !!searchQ && hasSubItems && child.subItems.some(s => matchesSearch(s.label));
                const subOpen = subMatchedBySearch || (child.key === 'reports-stocks' ? stockReportsOpen : false);
                const visibleSubItems = subMatchedBySearch
                  ? child.subItems.filter(s => matchesSearch(s.label) || matchesSearch(child.label))
                  : (child.subItems || []);
                return (
                <React.Fragment key={child.key}>
                  <button className={'sidebar-item child' + (activePage === child.key || (hasSubItems && child.subItems.some(s => s.key === activePage)) ? ' active' : '')}
                    onClick={() => {
                      if (hasSubItems && child.key === 'reports-stocks') {
                        setStockReportsOpen(o => !o);
                      } else {
                        navigate(child.key);
                      }
                    }}
                    title={!sidebarOpen ? nl(child.label) : ''}>
                    <span className="sidebar-icon">{getIcon(child.icon)}</span>
                    {sidebarOpen && <span className="sidebar-label" style={{ flex: 1 }}>{nl(child.label)}</span>}
                    {sidebarOpen && hasSubItems && <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', marginRight: 2, lineHeight: 1 }}>{subOpen ? '−' : '+'}</span>}
                  </button>
                  {hasSubItems && subOpen && sidebarOpen && visibleSubItems.map(g => (
                    <button
                      key={g.key}
                      className={'sidebar-item child' + (activePage === g.key ? ' active' : '')}
                      onClick={() => navigate(g.key)}
                      title={!sidebarOpen ? nl(g.label) : ''}
                      style={{ paddingLeft: 48 }}
                    >
                      <span className="sidebar-icon" style={{ opacity: 0.85 }}>{getIcon(g.icon)}</span>
                      <span className="sidebar-label" style={{ fontSize: '0.78rem' }}>{nl(g.label)}</span>
                    </button>
                  ))}
                </React.Fragment>
                );
              })}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-item" onClick={toggleTheme} title={t('nav.theme')}>
            <span className="sidebar-icon">
              {theme === 'dark' ?
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg> :
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
              }
            </span>
            {sidebarOpen && <span className="sidebar-label">{theme === 'dark' ? t('nav.lightMode') : t('nav.darkMode')}</span>}
          </button>
        </div>
      </aside>}

      {/* MAIN AREA */}
      <div className="mdi-main" style={isCashier ? { marginLeft: 0 } : undefined}>
        {/* TOP BAR */}
        <header className="mdi-topbar">
          <div className="mdi-topbar-left">
            {!isCashier && <button className="mdi-hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </button>}
            {isCashier && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingRight: 14, borderRight: '1px solid var(--border-secondary)', marginRight: 6 }}>
                <img src="/logo.png" alt="Hent" style={{ width: 32, height: 32, objectFit: 'contain' }} />
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                  <span style={{ fontSize: '1rem', fontWeight: 700, color: 'var(--accent-primary)' }}>Hent</span>
                  <span style={{ fontSize: '0.62rem', color: 'var(--text-tertiary)', fontWeight: 500, letterSpacing: '0.3px' }}>İşinizin Akıllı Merkezi</span>
                </div>
              </div>
            )}
            {isCashier && activePage !== 'retail-hub' && (
              <button onClick={() => navigate('retail-hub')} title="Mağaza ana ekrana dön"
                style={{ background: 'var(--accent-primary)', color: 'white', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem', marginRight: 8 }}>
                🏪 Mağaza
              </button>
            )}
            <span className="mdi-topbar-company">{company?.name}</span>
            <span className="mdi-topbar-pagetitle">{pageTitles[activePage] || ''}</span>
          </div>
          <div className="mdi-topbar-right">
            {/* DÖNEM SEÇİCİ */}
            {!isSuperAdmin && <div style={{position:'relative'}}>
              <button
                onClick={() => setShowPeriodMenu(!showPeriodMenu)}
                disabled={periodSwitching}
                title="Aktif çalışma dönemi"
                style={{
                  display:'flex', alignItems:'center', gap:6,
                  padding:'6px 10px', marginRight:10,
                  background: activePeriod ? 'var(--bg-secondary)' : 'rgba(220,38,38,0.1)',
                  border: '1px solid var(--border-secondary)',
                  borderRadius: 8, color: 'var(--text-primary)',
                  cursor: periodSwitching ? 'wait' : 'pointer',
                  fontSize:'0.82rem', fontWeight:600,
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <span>{periodSwitching ? 'Değişiyor...' : (activePeriod ? `Dönem: ${activePeriod.code}` : 'Dönem yok')}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              {showPeriodMenu && (
                <div className="mdi-user-dropdown" style={{minWidth:240}} onClick={(e) => e.stopPropagation()}>
                  <div className="mdi-dropdown-header">
                    <div style={{fontWeight:600, fontSize:'0.82rem'}}>Çalışma Dönemi Seç</div>
                    <div style={{fontSize:'0.72rem', color:'var(--text-tertiary)', marginTop:2}}>Tüm hareketler bu döneme yazılır</div>
                  </div>
                  {periods.length === 0 && (
                    <div style={{padding:12, fontSize:'0.78rem', color:'var(--text-tertiary)'}}>Tanımlı dönem yok</div>
                  )}
                  {periods.map(p => (
                    <button key={p.id}
                      className="mdi-dropdown-item"
                      onClick={() => handleSelectPeriod(p.id)}
                      style={{
                        display:'flex', alignItems:'center', justifyContent:'space-between',
                        background: p.id === activePeriod?.id ? 'rgba(99,102,241,0.08)' : 'transparent',
                        opacity: p.is_active === false ? 0.5 : 1,
                      }}
                      disabled={p.is_active === false}
                    >
                      <span>
                        <strong>{p.code}</strong>
                        {p.name && p.name !== p.code && <span style={{marginLeft:6, fontWeight:400, color:'var(--text-secondary)'}}>{p.name}</span>}
                      </span>
                      <span style={{fontSize:'0.7rem', color: p.status === 'closed' ? '#dc2626' : '#16a34a'}}>
                        {p.status === 'closed' ? 'Kapalı' : 'Açık'}
                      </span>
                    </button>
                  ))}
                  {isAdmin && <>
                    <div className="mdi-dropdown-sep"></div>
                    <button className="mdi-dropdown-item" onClick={() => { setShowPeriodMenu(false); navigate('fiscalperiods'); }}>
                      Dönemleri Yönet…
                    </button>
                  </>}
                </div>
              )}
            </div>}

            {/* HATIRLATMA ÇANI — super_admin için yok */}
            {!isSuperAdmin && <div style={{position:'relative', marginRight: 10}}>
              <button
                onClick={() => {
                  // Çana tıklandığında izin yoksa iste (user gesture — mobil tarayıcılar için zorunlu)
                  if ('Notification' in window && Notification.permission === 'default') {
                    try { Notification.requestPermission(); } catch {}
                  }
                  setShowReminderMenu(!showReminderMenu);
                }}
                title={
                  ('Notification' in window && Notification.permission === 'denied')
                    ? 'Bildirim izni reddedilmiş — tarayıcı ayarlarından aç'
                    : 'Bildirimler'
                }
                style={{
                  position: 'relative',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  width: 36, height: 36,
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-secondary)',
                  borderRadius: 8, color: 'var(--text-primary)',
                  cursor: 'pointer',
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
                {(reminders.length + unreadMessages.length + pendingApprovals.length + notifications.length) > 0 && (
                  <span style={{
                    position:'absolute', top: -4, right: -4,
                    minWidth: 18, height: 18, padding: '0 4px',
                    background: '#dc2626', color: '#fff',
                    borderRadius: 9, fontSize: '0.66rem', fontWeight: 700,
                    display:'flex', alignItems:'center', justifyContent:'center',
                    border: '2px solid var(--bg-primary)',
                  }}>{(reminders.length + unreadMessages.length + pendingApprovals.length + notifications.length) > 99 ? '99+' : (reminders.length + unreadMessages.length + pendingApprovals.length + notifications.length)}</span>
                )}
              </button>
              {showReminderMenu && (
                <div className="mdi-user-dropdown" style={{minWidth: 340, maxHeight: 520, overflowY: 'auto'}} onClick={(e) => e.stopPropagation()}>
                  {/* HATIRLATMALAR */}
                  <div className="mdi-dropdown-header" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <div>
                      <div style={{fontWeight:600, fontSize:'0.82rem'}}>Randevu Hatırlatmaları</div>
                      <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>{reminders.length} bekleyen</div>
                    </div>
                    {reminders.length > 0 && (
                      <button
                        className="btn-ghost"
                        style={{fontSize:'0.7rem', padding:'2px 6px'}}
                        onClick={() => reminders.forEach(r => dismissReminder(r.reminder_id))}
                      >Tümünü kapat</button>
                    )}
                  </div>
                  {reminders.length === 0 && (
                    <div style={{padding:'10px 12px', fontSize:'0.76rem', color:'var(--text-tertiary)', textAlign:'center'}}>Bekleyen hatırlatma yok</div>
                  )}
                  {reminders.map(r => (
                    <div key={r.reminder_id} style={{padding:'10px 12px', borderBottom: '1px solid var(--border-secondary)'}}>
                      <div style={{display:'flex', justifyContent:'space-between', gap:8, marginBottom:4}}>
                        <strong style={{fontSize:'0.82rem', color:'var(--text-primary)', flex:1}}>{r.title}</strong>
                        <button
                          onClick={(e) => { e.stopPropagation(); dismissReminder(r.reminder_id); }}
                          title="Görüldü"
                          style={{background:'transparent', border:'none', color:'var(--text-tertiary)', cursor:'pointer', padding:'0 2px'}}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        </button>
                      </div>
                      <div style={{fontSize:'0.72rem', color:'var(--text-secondary)'}}>
                        {fmtRemTime(r.start_at)}
                        {r.account_title && ' · ' + r.account_title}
                        {(r.personnel_first_name || r.personnel_last_name) && ' · ' + (r.personnel_first_name || '') + ' ' + (r.personnel_last_name || '')}
                      </div>
                      {r.location && <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>📍 {r.location}</div>}
                      <button
                        className="btn-ghost"
                        style={{fontSize:'0.7rem', padding:'2px 6px', marginTop:6}}
                        onClick={openReminderAppointment}
                      >Takvimde aç</button>
                    </div>
                  ))}

                  {/* MESAJLAR */}
                  <div className="mdi-dropdown-header" style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderTop:'2px solid var(--border-secondary)', marginTop: 4}}>
                    <div>
                      <div style={{fontWeight:600, fontSize:'0.82rem'}}>Mesajlar</div>
                      <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>{unreadMessages.length} okunmamış</div>
                    </div>
                    {unreadMessages.length > 0 && (
                      <button
                        className="btn-ghost"
                        style={{fontSize:'0.7rem', padding:'2px 6px'}}
                        onClick={async () => { try { await api.post('/messages/read-all'); setUnreadMessages([]); } catch {} }}
                      >Tümünü okundu</button>
                    )}
                  </div>
                  {unreadMessages.length === 0 && (
                    <div style={{padding:'10px 12px', fontSize:'0.76rem', color:'var(--text-tertiary)', textAlign:'center'}}>Yeni mesaj yok</div>
                  )}
                  {unreadMessages.slice(0, 10).map(m => (
                    <div
                      key={m.id}
                      style={{padding:'10px 12px', borderBottom: '1px solid var(--border-secondary)', cursor:'pointer'}}
                      onClick={() => openMessagePage(m.id, m)}
                    >
                      <div style={{display:'flex', justifyContent:'space-between', gap:8, marginBottom:4}}>
                        <strong style={{fontSize:'0.82rem', color:'var(--text-primary)', flex:1}}>
                          {m.recipient_id ? '' : '🌐 '}
                          {m.sender_name || m.sender_username}
                          {m.subject ? ' — ' + m.subject : ''}
                        </strong>
                        <button
                          onClick={(e) => { e.stopPropagation(); dismissMessage(m.id); }}
                          title="Okundu"
                          style={{background:'transparent', border:'none', color:'var(--text-tertiary)', cursor:'pointer', padding:'0 2px'}}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        </button>
                      </div>
                      <div style={{fontSize:'0.74rem', color:'var(--text-secondary)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth: 280}}>
                        {m.body
                          ? m.body.replace(/\s+/g, ' ').slice(0, 100)
                          : (m.attachment_url ? '📷 Resim' : '')}
                      </div>
                      <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>{fmtRelative(m.created_at)}</div>
                    </div>
                  ))}
                  {unreadMessages.length > 10 && (
                    <div style={{padding:'8px 12px', textAlign:'center', fontSize:'0.74rem'}}>
                      <button className="btn-ghost" style={{fontSize:'0.74rem'}} onClick={() => openMessagePage(null)}>Tüm mesajları göster ({unreadMessages.length})</button>
                    </div>
                  )}

                  {/* BEKLEYEN ONAYLAR */}
                  <div className="mdi-dropdown-header" style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderTop:'2px solid var(--border-secondary)', marginTop: 4}}>
                    <div>
                      <div style={{fontWeight:600, fontSize:'0.82rem'}}>Bekleyen Onaylar</div>
                      <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>{pendingApprovals.length} bekliyor</div>
                    </div>
                    {pendingApprovals.length > 0 && (
                      <button className="btn-ghost" style={{fontSize:'0.7rem', padding:'2px 6px'}}
                        onClick={() => { setShowReminderMenu(false); navigate('pending-approvals'); }}>
                        Hepsini Aç
                      </button>
                    )}
                  </div>
                  {pendingApprovals.length === 0 && (
                    <div style={{padding:'10px 12px', fontSize:'0.76rem', color:'var(--text-tertiary)', textAlign:'center'}}>Bekleyen onay yok</div>
                  )}
                  {pendingApprovals.slice(0, 10).map(a => {
                    const moduleLabels = { invoice: 'Fatura', waybill: 'İrsaliye', order: 'Sipariş', quote: 'Teklif' };
                    const dirLabels    = { sales: 'Satış', purchase: 'Alış' };
                    return (
                      <div key={a.id}
                        style={{padding:'10px 12px', borderBottom:'1px solid var(--border-secondary)', cursor:'pointer'}}
                        onClick={() => { setShowReminderMenu(false); navigate('pending-approvals'); }}>
                        <div style={{display:'flex', justifyContent:'space-between', gap:8, marginBottom:4}}>
                          <strong style={{fontSize:'0.82rem', color:'var(--text-primary)', flex:1}}>
                            ✓ {moduleLabels[a.module] || a.module} / {dirLabels[a.direction] || a.direction}
                            {a.document_number ? ' — ' + a.document_number : ''}
                          </strong>
                        </div>
                        <div style={{fontSize:'0.74rem', color:'var(--text-secondary)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth: 300}}>
                          {a.account_title || ''}
                          {a.total_amount ? ' · ' + parseFloat(a.total_amount).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL' : ''}
                          {a.current_level_name ? ' · Seviye: ' + a.current_level_name : ''}
                        </div>
                        <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>
                          {a.hierarchy_name || ''}
                          {a.created_at && ' · ' + fmtRelative(a.created_at)}
                        </div>
                      </div>
                    );
                  })}
                  {pendingApprovals.length > 10 && (
                    <div style={{padding:'8px 12px', textAlign:'center', fontSize:'0.74rem'}}>
                      <button className="btn-ghost" style={{fontSize:'0.74rem'}}
                        onClick={() => { setShowReminderMenu(false); navigate('pending-approvals'); }}>
                        Tüm bekleyen onaylar ({pendingApprovals.length})
                      </button>
                    </div>
                  )}

                  {/* BİLDİRİMLER — Generic notification center */}
                  <div className="mdi-dropdown-header" style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderTop:'2px solid var(--border-secondary)', marginTop: 4}}>
                    <div>
                      <div style={{fontWeight:600, fontSize:'0.82rem'}}>Bildirimler</div>
                      <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>{notifications.length} okunmamış</div>
                    </div>
                    {notifications.length > 0 && (
                      <button
                        className="btn-ghost"
                        style={{fontSize:'0.7rem', padding:'2px 6px'}}
                        onClick={async () => { try { await api.post('/notifications/read-all'); setNotifications([]); } catch {} }}
                      >Tümünü okundu</button>
                    )}
                  </div>
                  {notifications.length === 0 && (
                    <div style={{padding:'10px 12px', fontSize:'0.76rem', color:'var(--text-tertiary)', textAlign:'center'}}>Yeni bildirim yok</div>
                  )}
                  {notifications.slice(0, 10).map(n => {
                    const KIND_ICONS = {
                      approval_pending: '⏳', approval_resolved: '✓',
                      edocument_rejected: '⚠', edocument_sent: '📤',
                      stock_low: '📦', cek_due: '💳', system: '🔔',
                    };
                    const onOpen = async () => {
                      try { await api.post('/notifications/' + n.id + '/read'); } catch {}
                      setNotifications(prev => prev.filter(x => x.id !== n.id));
                      setShowReminderMenu(false);
                      if (n.link) navigate(n.link);
                    };
                    const onDismiss = async (e) => {
                      e.stopPropagation();
                      try { await api.post('/notifications/' + n.id + '/read'); } catch {}
                      setNotifications(prev => prev.filter(x => x.id !== n.id));
                    };
                    return (
                      <div key={n.id}
                        style={{padding:'10px 12px', borderBottom:'1px solid var(--border-secondary)', cursor:'pointer'}}
                        onClick={onOpen}>
                        <div style={{display:'flex', justifyContent:'space-between', gap:8, marginBottom:4}}>
                          <strong style={{fontSize:'0.82rem', color:'var(--text-primary)', flex:1}}>
                            {KIND_ICONS[n.kind] || '🔔'} {n.title}
                          </strong>
                          <button onClick={onDismiss} title="Okundu"
                            style={{background:'transparent', border:'none', color:'var(--text-tertiary)', cursor:'pointer', padding:'0 2px'}}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                          </button>
                        </div>
                        {n.body && (
                          <div style={{fontSize:'0.74rem', color:'var(--text-secondary)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth: 300}}>
                            {n.body}
                          </div>
                        )}
                        <div style={{fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:2}}>{fmtRelative(n.created_at)}</div>
                      </div>
                    );
                  })}
                  {notifications.length > 10 && (
                    <div style={{padding:'8px 12px', textAlign:'center', fontSize:'0.74rem'}}>
                      <span style={{color:'var(--text-tertiary)'}}>+{notifications.length - 10} daha</span>
                    </div>
                  )}
                </div>
              )}
            </div>}

            <div style={{position:'relative'}}>
              <button className="mdi-user-btn" onClick={() => setShowUserMenu(!showUserMenu)}>
                <div className="mdi-avatar" style={user?.imageUrl ? { padding: 0, overflow: 'hidden' } : undefined}>
                  {user?.imageUrl
                    ? <img src={user.imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                    : initials(user?.fullName)}
                </div>
                <div className="mdi-user-info">
                  <span className="mdi-user-name">{user?.fullName}</span>
                  <span className="mdi-user-role">{roleName(user?.role)}</span>
                </div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              {showUserMenu && (
                <div className="mdi-user-dropdown" onClick={() => setShowUserMenu(false)}>
                  <div className="mdi-dropdown-header">
                    <div style={{fontWeight:600,fontSize:'0.85rem'}}>{user?.fullName}</div>
                    <div style={{fontSize:'0.75rem',color:'var(--text-tertiary)',marginTop:2}}>{user?.email}</div>
                    <div style={{fontSize:'0.7rem',color:'var(--accent-primary)',marginTop:4}}>{company?.name} - {company?.code}</div>
                  </div>
                  <button className="mdi-dropdown-item" onClick={toggleTheme}>
                    {theme === 'dark' ? (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>
                    ) : (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
                    )}
                    {theme === 'dark' ? 'Aydınlık Moda Geç' : 'Karanlık Moda Geç'}
                  </button>
                  <button className="mdi-dropdown-item" onClick={(e) => { e.stopPropagation(); togglePush(); }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      {pushSubscribed
                        ? <><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></>
                        : <><path d="M13.73 21a2 2 0 0 1-3.46 0"/><path d="M2 2l20 20"/><path d="M6 8a6 6 0 0 1 12 0c0 1.6.2 3 .5 4.2"/></>}
                    </svg>
                    Push Bildirim: <strong style={{ marginLeft: 'auto' }}>{pushBusy ? '...' : (pushSubscribed ? 'Açık' : 'Kapalı')}</strong>
                  </button>
                  <button className="mdi-dropdown-item" onClick={(e) => { e.stopPropagation(); setShowUserMenu(false); setKbdHelpOpen(true); }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="14" rx="2"/><path d="M6 12h.01M10 12h.01M14 12h.01M18 12h.01M6 16h12"/></svg>
                    {t('nav.keyboardShortcuts', 'Klavye Kısayolları')} (?)
                  </button>
                  {/* Dil seçici — dropdown içinde, kapanmasın diye stopPropagation */}
                  <div className="mdi-dropdown-item" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'default' }} onClick={e => e.stopPropagation()}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                    <span style={{ flex: 1 }}>{t('settings.language')}</span>
                    <LangSwitcher variant="compact" />
                  </div>
                  <div className="mdi-dropdown-sep"></div>
                  <button className="mdi-dropdown-item danger" onClick={logout}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                    {t('nav.logout')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Abonelik durumu uyarısı (sadece kritik durumlarda) */}
        {!isSuperAdmin && <SubscriptionBanner />}

        {/* BREADCRUMB — Ana Sayfa › Kategori › Aktif Sayfa */}
        <Breadcrumb activePage={activePage} onNavigate={navigate} />

        {/* CONTENT AREA — dönem değişince tüm sayfa state'i temizlenir */}
        <div className="mdi-content" key={`${activePeriod?.id || 'no-period'}-${activePage}`}>
          {renderContent()}
        </div>
      </div>

      {/* Mobile overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}

      {/* Command Palette — Ctrl/Cmd+K */}
      <CommandPalette
        open={cmdkOpen}
        onClose={() => setCmdkOpen(false)}
        onNavigate={navigate}
        menuItems={[
          ...cariChildItems,
          ...salesModuleChildItems,
          ...retailModuleChildItems,
          ...purchaseModuleChildItems,
          ...quotesChildItems,
          ...ordersChildItems,
          ...waybillsChildItems,
          ...bankChildItems,
          ...cashChildItems,
          ...cekChildItems,
          ...senetChildItems,
          ...muhasebeChildItems,
          ...ebelgeChildItems,
          ...stokChildItems,
          ...reportsChildItems,
          ...personelChildItems,
          ...programChildItems,
          ...approvalsChildItems,
          ...eklentilerChildItems,
          { key: 'dashboard',     label: 'Ana Sayfa' },
          { key: 'appointments',  label: 'Randevu / Ajanda' },
          { key: 'messages',      label: 'Mesajlar' },
          { key: 'support',       label: 'Destek Talepleri' },
          { key: 'subscription',  label: 'Aboneliğim' },
        ]}
        quickActions={[
          { label: '🎯 CRM Pipeline\'a git',         onAction: () => navigate('crm-pipeline') },
          { label: '+ Yeni Potansiyel Cari',         onAction: () => navigate('prospect-accounts') },
          { label: '+ Yeni Cari Hesap',              onAction: () => navigate('accounts') },
          { label: '+ Yeni Stok',                    onAction: () => navigate('stocks') },
          { label: '📋 Onay Bekleyenler',            onAction: () => navigate('pending-approvals') },
          { label: theme === 'dark' ? '☀ Aydınlık Moda Geç' : '🌙 Karanlık Moda Geç', onAction: toggleTheme },
          { label: '⌨ Klavye Kısayolları',           onAction: () => setKbdHelpOpen(true) },
          { label: '⚙ Ayarlar',                      onAction: () => navigate('settings') },
        ]}
      />

      <KeyboardHelp open={kbdHelpOpen} onClose={() => setKbdHelpOpen(false)} />

      {/* MOBİL ALT NAV — sadece 768px altında görünür */}
      <BottomNav
        activePage={activePage}
        onNavigate={navigate}
        unreadCount={reminders.length + unreadMessages.length + pendingApprovals.length + notifications.length}
        onOpenSidebar={() => setSidebarOpen(true)}
        onOpenCommandPalette={() => setCmdkOpen(true)}
        onOpenNotifications={() => setShowReminderMenu(true)}
      />
    </div>
  );
}
export default MainLayout;
